import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'; // Adiciona useRef, useMemo e useCallback
import { Button, Table, Tab, Tabs, Form, ListGroup, Spinner, Modal, Dropdown, Row, Col, Alert, InputGroup, Accordion, Badge, Toast, ToastContainer, OverlayTrigger, Tooltip, Card, ButtonGroup, Popover } from 'react-bootstrap'; // Adicionado Toast e ToastContainer
import { useNavigate } from 'react-router-dom'; // Adicionado para navegação
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck, faCalendarAlt, faUserMd, faDollarSign, faBan, faMoneyBillWave, faBullhorn, faStethoscope, faExpand, faCheckCircle, faArrowLeft, faPhone, faEnvelope, faIdCard, faClock, faBars } from '@fortawesome/free-solid-svg-icons';

import { useUserContext } from '../../UserContext';
import { useAuthContext } from '../../context/AuthContext';
import { useEntidadeContext } from '../../EntidadeContext';
import { usePacienteContext } from '../../PacienteContext';
import { useAlertModal } from '../../AlertModalContext';

import PaymentModal from '../../pages/PaymentModal';
import CommunicationModal from './CommunicationModal';
import ProntuarioVisualizacaoModal from './ProntuarioVisualizacaoModal';

import addPatientIcon from '../../img/icoPlusPaciente.jpg';
import '../../Agendas.css';

// Função para normalizar strings (remover acentos e converter para minúsculas) para a busca
function normalizeString(str) {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

const formatCurrency = (value) => {
  // Garante que o valor seja um número antes de formatar
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value) || 0);
};

// Helper function to determine the current period of the day
const getCurrentPeriod = () => {
  const currentHour = new Date().getHours();
  if (currentHour <= 12) {
    return 'Manhã';
  } else if (currentHour <= 17) {
    return 'Tarde';
  } else {
    return 'Noite';
  }
};

// Função auxiliar para definir a cor do badge com base no status do agendamento
const getStatusColors = (status) => {
  // Normaliza o status removendo espaços em branco nas extremidades e garantindo que seja string
  const normalizedStatus = status ? String(status).trim() : '';

  switch (normalizedStatus) {
    case 'Realizada':
      return { bg: '#5ab46f', text: '#fff' }; // Verde vibrante
    case 'Em andamento':
      return { bg: '#ffc107', text: '#000' }; // Amarelo vibrante
    case 'Agendada':
      return { bg: '#609df8', text: '#fff' }; // Azul vibrante
    case 'Cancelada':
      return { bg: '#ee969f', text: '#fff' }; // Vermelho vibrante
    case 'Faltou':
      return { bg: '#343a40', text: '#fff' }; // Escuro
    case 'Desmarcada':
      return { bg: '#6c757d', text: '#fff' }; // Cinza
    case 'Aguardando Pagamento':
      return { bg: '#0dcaf0', text: '#000' }; // Ciano vibrante
    default:
      // Log para identificar o que está chegando errado (verifique o console do navegador)
      console.warn(`[getStatusColors] Caiu no default. Valor recebido: "${status}" | Tipo: ${typeof status}`);
      return { bg: '#f8f9fa', text: '#000' }; // Claro
  }
};

const AgendasCardTab = ({
  isActive,
  especialidades,
  todosMedicos,
  allFuncionarios, // Adiciona a nova prop aqui
  servicos,
  pacientesList, // Recebe a lista de pacientes do pai
  selectedEspecialidade, // Recebe o estado do pai
  setSelectedEspecialidade, // Recebe o setter do pai
  selectedMedico, // Recebe o estado do pai
  setSelectedMedico, // Recebe o setter do pai
  selectedDate, // Recebe o estado do pai
  setSelectedDate, // Recebe o setter do pai
  calendarAppointments, // Recebe os agendamentos do dia do pai
  isLoadingCalendarData, // Recebe o loading do pai
  onAppointmentCreated, // Callback para o pai
  onAppointmentStatusChange, // Callback para o pai
  onAppointmentFinalized, // Callback para o pai 
  onPatientCreated, // NOVO: Callback para notificar a criação de um novo paciente
  refreshKey, // NOVO: Recebe a chave de atualização do pai
  isCurrentUserCorpoClinico, // Recebe a flag do pai
  ordemDeChegada, // Prop para a nova aba
  isLoadingOrdemDeChegada, // Prop para a nova aba
  // All other props remain the same
  horariosAtendimento, // Recebe do pai
  totalSlotsDisponiveis, // Recebe do pai,
  onPatientInterestsUpdate, 
  feriadosNacionais, // Recebe do pai
  getFeriadoNome, // Recebe do pai (agora dinâmico)
  isDiaBloqueado, // NOVO: Recebe do pai
  agendaHorariosGerados, // NOVO: Recebe do pai
}) => {
  const { showAlertModal } = useAlertModal();

  const { currentEntidade } = useEntidadeContext(); // Usar contexto
  const { currentUserRole, getPermittedInternalTabs } = useUserContext(); // Mantém para a role, se ainda for útil separadamente
  const navigate = useNavigate(); // Adicionado para navegação
  const { loggedInUser: currentUser } = useAuthContext(); // Obter o usuário completo do AuthContext
  const { setPacienteSelecionado } = usePacienteContext(); // Importe o hook

  // useMemo to determine the default active accordion key based on the current time
  const defaultActiveAccordionKey = useMemo(() => getCurrentPeriod(), []);

  // Obter permissões do módulo Consultório para controlar botões
  const consultorioPermissions = useMemo(() =>
      getPermittedInternalTabs('consultorio', currentUserRole),
    [getPermittedInternalTabs, currentUserRole]
  );

  const canShowPayButton = useMemo(() => 
    consultorioPermissions.some(p => p.key === 'show_botao_pagar'), 
  [consultorioPermissions]);

  const canShowCancelPayButton = useMemo(() => 
    consultorioPermissions.some(p => p.key === 'show_botao_cancelar_pagamento'), 
  [consultorioPermissions]);

  // Estados locais do componente
  const [showCalendarModal, setShowCalendarModal] = useState(false); // Estado para o modal do calendário
  const [loadingIniciarConsulta, setLoadingIniciarConsulta] = useState({});
  const [loadingCheckIn, setLoadingCheckIn] = useState({}); // Novo estado para o loading do check-in
  const [showCreatePatientModal, setShowCreatePatientModal] = useState(false);
  const [isCreatingPatient, setIsCreatingPatient] = useState(false); // NOVO: Estado para o loading do cadastro de paciente
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedAppointmentForPayment, setSelectedAppointmentForPayment] = useState(null);

  const [selectedServicos, setSelectedServicos] = useState([]); // Add state to hold selected service IDs
  const [allInteresses, setAllInteresses] = useState([]); // Estado para todos os interesses

  // Estados para o modal de reagendamento
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [appointmentToReschedule, setAppointmentToReschedule] = useState(null);
  const [newScheduleDate, setNewScheduleDate] = useState(new Date());
  const [newAvailableSlots, setNewAvailableSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [selectedNewTime, setSelectedNewTime] = useState(null);
  const [isLoadingReschedule, setIsLoadingReschedule] = useState(false);

  const [localHorariosAtendimento, setLocalHorariosAtendimento] = useState(horariosAtendimento);
    const [isLoadingBulkWhatsApp, setIsLoadingBulkWhatsApp] = useState(false); // NOVO: Estado de loading para envio em massa

  // Estados locais para a aba "Todos os Médicos" (movidos do Consultorio.js)
  const [allAppointmentsForDay, setAllAppointmentsForDay] = useState([]);
  const [isLoadingAllAppointments, setIsLoadingAllAppointments] = useState(false);
  const [allAppointmentsError, setAllAppointmentsError] = useState(null);

  // --- NEW: View Logic (Day, 5-Day, Week, Month) ---
  const [fiveDayAppointments, setFiveDayAppointments] = useState([]);
  const [loadingFiveDays, setLoadingFiveDays] = useState(false);
  const [redLineTop, setRedLineTop] = useState(-1);
  const [activeStartDate, setActiveStartDate] = useState(new Date(selectedDate)); // Estado local para o mês do calendário
  const [availabilityData, setAvailabilityData] = useState({}); // Estado local para disponibilidade
  const [nextAvailableDate, setNextAvailableDate] = useState(null); // Estado local para próxima data
  const [calendarStatus, setCalendarStatus] = useState(null); // Estado local para status do dia
  
  // --- RESPONSIVIDADE ---
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);

  useEffect(() => {
      const handleResize = () => {
          setWindowWidth(window.innerWidth);
          if (window.innerWidth >= 992) {
              setIsSidebarOpen(true);
          }
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 576;
  const isTablet = windowWidth >= 576 && windowWidth < 992;
  const isDesktop = windowWidth >= 992;

  const [viewMode, setViewMode] = useState(isDesktop ? 'week' : 'day'); // 'day', 'week', 'month'
  const scrollRef = useRef(null); // Ref para o container de scroll

  const [activeTab, setActiveTab] = useState('agenda');
  const [showOnlyPendingPayment, setShowOnlyPendingPayment] = useState(false); // NOVO: Estado para o filtro de pagamento
  const [showActionsModal, setShowActionsModal] = useState(false);
  const [selectedAppointmentForActions, setSelectedAppointmentForActions] = useState(null);
  const [resizeState, setResizeState] = useState(null); // NOVO: Estado para redimensionamento
  const [draggedAppointment, setDraggedAppointment] = useState(null); // NOVO: Estado para drag and drop
  const [hoveredAppointmentId, setHoveredAppointmentId] = useState(null); // NOVO: Estado para hover do card
  const [contextMenu, setContextMenu] = useState(null); // NOVO: Estado para o menu de contexto
  const [showProntuarioModal, setShowProntuarioModal] = useState(false); // NOVO: Estado para o modal de prontuário
  const [patientForModal, setPatientForModal] = useState(null); // NOVO: Paciente selecionado para o modal
  const [selectedSidebarAppointment, setSelectedSidebarAppointment] = useState(null); // NOVO: Estado para controlar a visualização da sidebar
  const [showPackageHistoryModal, setShowPackageHistoryModal] = useState(false); // NOVO: Modal de histórico de pacotes
  const [packageHistoryData, setPackageHistoryData] = useState([]); // NOVO: Dados do histórico
  const [isLoadingPackageHistory, setIsLoadingPackageHistory] = useState(false); // NOVO: Loading do histórico
  const [sidebarDetails, setSidebarDetails] = useState({ services: [], total: 0, loading: false, valorAdicional: 0, valorDesconto: 0, valorJaPago: 0 }); // NOVO: Detalhes financeiros da sidebar

  // --- NOVOS ESTADOS PARA ADICIONAR COMISSÃO ---
  const [editingCommission, setEditingCommission] = useState({ paymentId: null, serviceId: null });
  const [selectedProfessionalForCommission, setSelectedProfessionalForCommission] = useState('');
  const [commissionPercentage, setCommissionPercentage] = useState('');
  const [isAddingCommission, setIsAddingCommission] = useState(false);
  const [commissionableEmployees, setCommissionableEmployees] = useState([]);

  // Garante que a visualização de mês não fique ativa em mobile/tablet
  useEffect(() => {
    if (!isDesktop && viewMode === 'month') {
        setViewMode('day');
    }
  }, [isDesktop, viewMode]);

  // --- NOVO: Configuração dinâmica do intervalo de horas baseada na entidade ---
  const { startHour, endHour } = useMemo(() => {
    if (!currentEntidade?.horarios || currentEntidade.horarios.length === 0) {
        return { startHour: 7, endHour: 23 }; // Fallback padrão
    }

    let min = 24;
    let max = 0;

    currentEntidade.horarios.forEach(h => {
        if (h.ativo) {
            // Verifica todos os horários de início e fim configurados
            const times = [
                h.manha_inicio, h.manha_fim,
                h.tarde_inicio, h.tarde_fim,
                h.noite_inicio, h.noite_fim
            ];
            
            times.forEach(t => {
                if (t) {
                    const hour = parseInt(t.split(':')[0], 10);
                    if (hour < min) min = hour;
                    if (hour > max) max = hour;
                }
            });
        }
    });

    // Se não encontrou horários válidos (ex: tudo inativo), usa o padrão
    if (min === 24) min = 7;
    if (max === 0) max = 23;

    return { startHour: min, endHour: max };
  }, [currentEntidade]);

  // --- NOVO: Intervalo de visualização da agenda (slots) ---
  const slotInterval = useMemo(() => {
    return currentEntidade?.intervalo_agenda || currentEntidade?.duracao_padrao_consulta || 60;
  }, [currentEntidade]);

  // Busca funcionários comissionáveis para o dropdown
  useEffect(() => {
    if (currentEntidade?.id) {
        axios.get(`/api/relatorios/funcionarios-comissionaveis`, { params: { entidade_id: currentEntidade.id } })
            .then(res => setCommissionableEmployees(res.data.funcionarios || []))
            .catch(console.error);
    }
  }, [currentEntidade]);

  //Cadastro novo agendamento
  const [newAppointment, setNewAppointment] = useState({ // Local state for the form
    entidade_id: currentEntidade ? currentEntidade.id : null, // Usa do contexto (ainda local para o formulário)
    filial_id: '', // Usar string vazia
    especialidade_id: selectedEspecialidade || '', // Usar string vazia se não selecionado
    medico_id: selectedMedico || '', // Usar string vazia se não selecionado
    paciente_id: '', // Usar string vazia
    data_agendamento: null,
    hora_marcada: '', // Usar string vazia
    tipo: 'Consulta', // Valor padrão, altere se necessário
    status: 'Agendada', // Valor padrão, altere se necessário
    interesses: [], // Adicionar campo de interesses
  });

  const [newPatient, setNewPatient] = useState({ // Este estado é local para o formulário de criação
    nome: '',
    cpf: '',
    data_nascimento: '',
    sexo: '',
    email: '',
    dddcelular: '',
    celular: '',
    endereco: '',
    op_convenio: ''
    // ... outros campos do paciente
  });

  // Estados para o campo de busca de paciente customizado
  const [pacienteSearch, setPacienteSearch] = useState('');
  const [showPacientesDropdown, setShowPacientesDropdown] = useState(false);
  const pacienteDropdownRef = useRef(null);

  // Novos estados para pacotes de sessões do paciente
  const [pacientePacotesAtivos, setPacientePacotesAtivos] = useState([]);
  const [isLoadingPacotes, setIsLoadingPacotes] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);

  // Handler genérico para campos de input do formulário de novo paciente
  const handleNewPatientInputChange = (e) => {
    const { name, value } = e.target;
    setNewPatient(prev => ({ ...prev, [name]: value }));
  };

  // Handler específico para o campo de telefone com máscara
  const handleNewPatientPhoneChange = (e) => {
    const value = e.target.value;
    // Remove todos os caracteres não numéricos para obter apenas os dígitos
    const justNumbers = value.replace(/\D/g, '');
    const ddd = justNumbers.substring(0, 2);
    const number = justNumbers.substring(2);
    setNewPatient(prev => ({ ...prev, dddcelular: ddd, celular: number }));
  };

  // Local states for search and filtering
  const [searchInput, setSearchInput] = useState(''); // ADDED
  const [filteredEspecialidades, setFilteredEspecialidades] = useState([]); // ADDED
  const [filteredMedicos, setFilteredMedicos] = useState([]); // ADDED
  const [localMedicos, setLocalMedicos] = useState([]); // ADDED (to hold filtered doctors for local search)

  // Efeito para fechar o dropdown de pacientes ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pacienteDropdownRef.current && !pacienteDropdownRef.current.contains(event.target)) {
        setShowPacientesDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
 }, []);

    const [showModal, setShowModal] = useState(false); // ADDED

  // Efeito para buscar os pacotes ativos do paciente selecionado no modal
  useEffect(() => {
    const fetchPacotes = async () => {
      // Verifica se há um paciente selecionado no modal de novo agendamento
      if (showModal && newAppointment.paciente_id) {
        setIsLoadingPacotes(true);
        setPacientePacotesAtivos([]); // Limpa pacotes anteriores para evitar que serviços inativos persistam
        setSelectedServicos([]); // Limpa serviços selecionados ao trocar de paciente
        setSelectedPackageId(null);
        try {
          const response = await axios.get(`/api/pacientes/${newAppointment.paciente_id}/pacotes-ativos`);
          setPacientePacotesAtivos(response.data.pacotes_ativos || []);
        } catch (error) {
          console.error("Erro ao buscar pacotes do paciente:", error);
          setPacientePacotesAtivos([]); // Limpa em caso de erro
        } finally {
          setIsLoadingPacotes(false);
        }
      } else {
        // Limpa a lista de pacotes se não houver paciente selecionado ou se o modal fechar
        setPacientePacotesAtivos([]);
        setSelectedPackageId(null); // Limpa o pacote selecionado também
      }
    };

    fetchPacotes();
  }, [newAppointment.paciente_id, showModal]);

  // Efeito para buscar os interesses disponíveis
  useEffect(() => {
    const fetchInteresses = async () => {
      if (!currentEntidade || !showModal) return; // Só busca se o modal estiver aberto e a entidade carregada
      try {
        const response = await axios.get(`/api/interesses`); // A API já filtra pela entidade
        const formattedInteresses = (response.data.interesses || []).map(interesse => ({
          value: interesse.id,
          label: interesse.nome
        }));
        setAllInteresses(formattedInteresses);
      } catch (error) {
        console.error("Erro ao buscar tags de interesse:", error);
        setAllInteresses([]);
      }
    };
    fetchInteresses();
  }, [showModal, currentEntidade]);

  // Local states for new appointment modal
  const [isLoadingCreate, setIsLoadingCreate] = useState(false); // ADDED

  // NOVO: Estado para controlar se o modal foi aberto a partir de "Reutilizar Horário"
  const [isReusingSlot, setIsReusingSlot] = useState(false);

  // Função para navegar entre os meses e atualizar a data selecionada
  const handleMonthNavigation = (direction) => {
    // Baseia a navegação no mês atualmente visível no calendário (activeStartDate)
    const newActiveDate = new Date(activeStartDate);
    newActiveDate.setDate(1); // Define para o dia 1 para evitar problemas com meses de diferentes durações
    newActiveDate.setMonth(newActiveDate.getMonth() + direction);

    // Atualiza o mês de visualização do calendário E a data selecionada (para atualizar a lista de agendamentos)
    setActiveStartDate(newActiveDate);
    setSelectedDate(newActiveDate);
  };

  const handleGoToToday = () => {
    const today = new Date();
    setSelectedDate(today);
    setActiveStartDate(today);
  };

  const handleCheckIn = async (agendamentoId) => {
    setLoadingCheckIn(prev => ({ ...prev, [agendamentoId]: true }));
    try {
      const response = await axios.post(`/api/agendamentos/${agendamentoId}/check-in`);
      // Otimização: Passa o agendamento atualizado (com a hora_chegada) para o pai.
      // O pai (Consultorio.js) atualizará o estado localmente, evitando um re-fetch completo.
      onAppointmentStatusChange(response.data.agendamento);
      // showAlertModal('Sucesso', 'Check-in do paciente registrado!', 'success');
    } catch (error) {
      showAlertModal('Erro', `Falha ao registrar check-in: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setLoadingCheckIn(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };

  // Efeito para buscar TODOS os agendamentos do dia quando a aba "Todos os Médicos" estiver ativa
  useEffect(() => {
    const fetchAllAppointments = async () => {
        if (activeTab !== 'todos' || !currentEntidade) return;
        
        setIsLoadingAllAppointments(true);
        setAllAppointmentsError(null);
        try {
            const formattedDate = selectedDate.toISOString().split('T')[0];
            const response = await axios.get(`/api/agendamentos/entidade/${currentEntidade.id}/data/${formattedDate}`);
            setAllAppointmentsForDay(response.data.agendamentos || []);
        } catch (error) {
            console.error("Erro ao buscar todos os agendamentos:", error);
            setAllAppointmentsError("Erro ao carregar agendamentos.");
        } finally {
            setIsLoadingAllAppointments(false);
        }
    };
    fetchAllAppointments();
  }, [activeTab, selectedDate, currentEntidade, refreshKey]); // Adicionado refreshKey

  // Função auxiliar para encontrar a próxima data disponível (movida do Consultorio.js)
  const findNextAvailableDate = useCallback((startDate, endDate, currentAvailabilityData) => {
    let foundNextAvailable = null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let currentDate = new Date(Math.max(startDate.getTime(), today.getTime()));

    while (currentDate <= endDate) {
      const dateString = currentDate.toISOString().split('T')[0];
      const dayOfWeek = currentDate.getDay();
      const isHoliday = getFeriadoNome(currentDate);
      const count = currentAvailabilityData[dateString] || 0;
      if (dayOfWeek !== 0 && !isHoliday && count < totalSlotsDisponiveis) {
        foundNextAvailable = new Date(currentDate);
        break;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return foundNextAvailable;
  }, [getFeriadoNome, totalSlotsDisponiveis]);

  // Efeito para buscar a disponibilidade do MÊS INTEIRO (availabilityData)
  useEffect(() => {
    const fetchMonthAvailability = async () => {
      if (!selectedMedico || !activeStartDate || !currentEntidade) {
        setAvailabilityData({});
        setNextAvailableDate(null);
        return;
      }

      const year = activeStartDate.getFullYear();
      const month = activeStartDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1);
      const lastDayOfMonth = new Date(year, month + 1, 0);

      const startDateString = firstDayOfMonth.toISOString().split('T')[0];
      const endDateString = lastDayOfMonth.toISOString().split('T')[0];

      try {
        // Usa a rota unificada que já existe no backend
        const endpoint = `/api/agendamentos/entidade/${currentEntidade.id}/medico/${selectedMedico}/periodo?inicio=${startDateString}&fim=${endDateString}`;
        const response = await axios.get(endpoint);
        const monthAppointments = response.data.agendamentos || [];

        const dailyCounts = monthAppointments.reduce((acc, appointment) => {
          const date = appointment.data_agendamento;
          acc[date] = (acc[date] || 0) + 1;
          return acc;
        }, {});

        setAvailabilityData(dailyCounts);
        const newNextAvailable = findNextAvailableDate(firstDayOfMonth, lastDayOfMonth, dailyCounts);
        setNextAvailableDate(newNextAvailable);
      } catch (error) {
        console.error('Erro ao buscar disponibilidade do mês:', error);
      }
    };
    fetchMonthAvailability();
  }, [selectedMedico, activeStartDate, currentEntidade, findNextAvailableDate, refreshKey]); // Adicionado refreshKey para atualizar ao criar/editar

  // Agrupa os agendamentos da nova aba por médico
  const appointmentsByMedico = useMemo(() => {
    if (!allAppointmentsForDay) return {};
    return allAppointmentsForDay.reduce((acc, appointment) => {
      const medicoId = appointment.medico_id;
      if (!acc[medicoId]) {
        acc[medicoId] = [];
      }
      acc[medicoId].push(appointment);
      return acc;
    }, {});
  }, [allAppointmentsForDay]);

  // Efeito para definir o status do calendário (Feriado, Bloqueado, etc.)
  useEffect(() => {
    const feriadoNome = getFeriadoNome(selectedDate);
    const bloqueado = isDiaBloqueado(selectedDate);

    if (feriadoNome) {
      setCalendarStatus('Feriado');
    } else if (bloqueado) {
      setCalendarStatus('Bloqueado');
    } else {
      const dateString = selectedDate.toISOString().split('T')[0];
      if (availabilityData[dateString] >= totalSlotsDisponiveis) {
        setCalendarStatus('Sem vagas');
      } else {
        setCalendarStatus(null);
      }
    }
  }, [selectedDate, getFeriadoNome, isDiaBloqueado, availabilityData, totalSlotsDisponiveis]);

  // Estados para o novo modal unificado de comunicação
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  
  // NOVO: Estados para o modal de cancelamento de pagamento
  const [showCancelPaymentModal, setShowCancelPaymentModal] = useState(false);
  const [appointmentToCancelPayment, setAppointmentToCancelPayment] = useState(null);
  const [isCancelingPayment, setIsCancelingPayment] = useState(false);

  // NOVO: Estados para o modal de detalhes do pagamento
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);
  const [selectedPaymentDetails, setSelectedPaymentDetails] = useState(null);
  const [selectedAppointmentForDetails, setSelectedAppointmentForDetails] = useState(null);

  const handleServicoChange = (servicoId, pacoteId = null) => { // Este é um handler local para o modal de agendamento
    const isCurrentlySelected = selectedServicos.includes(servicoId);

    // Caso 1: Um serviço de pacote está sendo selecionado/desmarcado
    if (pacoteId) {
      if (isCurrentlySelected) {
        // Desmarcando o serviço do pacote
        setSelectedServicos([]);
        setSelectedPackageId(null);
      } else {
        // Marcando o serviço do pacote. Desmarca todos os outros.
        setSelectedServicos([servicoId]);
        setSelectedPackageId(pacoteId);
      }
    }
    // Caso 2: Um serviço normal está sendo selecionado/desmarcado
    else {
      // Se um pacote já estiver ativo, não permite adicionar serviços normais
      if (selectedPackageId) {
        return;
      }
      // Caso contrário, apenas alterna o serviço normal na lista
      setSelectedServicos(prev =>
        isCurrentlySelected ? prev.filter(id => id !== servicoId) : [...prev, servicoId]
      );
    }
  };

  // Função para abrir o modal de cadastro de paciente
  const handleOpenRescheduleModal = (appointment) => {
    setAppointmentToReschedule(appointment);
    // Inicializa o DatePicker com a data atual do agendamento, evitando problemas de fuso horário
    const [year, month, day] = appointment.data_agendamento.split('-').map(Number);
    setNewScheduleDate(new Date(year, month - 1, day));
    setSelectedNewTime(null);
    setShowRescheduleModal(true);
  };

  const handleCloseRescheduleModal = () => {
    setShowRescheduleModal(false);
    setAppointmentToReschedule(null);
    setSelectedNewTime(null);
    setNewAvailableSlots([]);
  };

  const handleOpenCreatePatientModal = () => {
    setShowCreatePatientModal(true);
  };

  // Função para fechar o modal de cadastro de paciente
  const handleCloseCreatePatientModal = () => {
    setShowCreatePatientModal(false);
    setNewPatient({
      nome: '',
      // ... outros campos do paciente
    });
  };

  // Função para lidar com a criação do paciente
  const handleCreatePatient = async () => {
    if (!currentEntidade) {
      showAlertModal('Erro', 'Nenhuma entidade selecionada. Não é possível criar o paciente.', 'danger');
      return;
    }
    try {
      setIsCreatingPatient(true); // Ativa o loading
      if (!newPatient.nome || !newPatient.cpf || !newPatient.email) {
        showAlertModal('Validação', 'Nome, CPF e Email são obrigatórios.', 'warning');
        // CORREÇÃO: Desativa o loading se a validação falhar.
        setIsCreatingPatient(false);
        return;
      }
      const patientDataWithEntity = { ...newPatient, entidade_id: currentEntidade.id };
      const response = await axios.post('/api/pacientes', patientDataWithEntity);
      const createdPaciente = response.data.paciente; // Define createdPaciente aqui
      handleCloseCreatePatientModal();

      // Notifica o componente pai (Consultorio.js) que um novo paciente foi criado.
      // O pai (Consultorio) chamará a função do EntidadeContext para atualizar a lista globalmente.
      if (onPatientCreated) {
        onPatientCreated(createdPaciente);
      }

      // Pré-seleciona o paciente recém-criado no modal de agendamento
      setNewAppointment(prevAppointment => ({ // Este setNewAppointment é para o modal de NOVO AGENDAMENTO
        ...prevAppointment,
        paciente_id: createdPaciente.id
      }));
    } catch (error) {
      console.error('Erro ao criar paciente:', error);
      showAlertModal('Erro de Conexão', `Erro ao criar paciente: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsCreatingPatient(false); // Desativa o loading
    }
  };

  const getTileClass = ({ date, view, getFeriadoNome, availabilityData, totalSlotsDisponiveis, nextAvailableDate }) => {
    // Ignora a aplicação de classes em visualizações diferentes de 'month'
    if (view !== 'month') {
      return '';
    }
    const validDate = date; // A data já é um objeto Date válido aqui

    // 1. Verifica se é feriado
    if (getFeriadoNome(validDate)) {
      return 'feriado';
    }

    // 2. Verifica se é um dia bloqueado especificamente
    if (isDiaBloqueado(validDate)) {
      return 'bloqueado';
    }

    // 3. Verifica se é um dia da semana inativo (sem horários)
    const diaDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][validDate.getDay()];
    const configDia = agendaHorariosGerados ? agendaHorariosGerados[diaDaSemana] : null;
    if (!configDia || (configDia['Manhã'].length === 0 && configDia['Tarde'].length === 0 && configDia['Noite'].length === 0)) {
      return 'bloqueado';
    }

    const formattedDateStringForAvailability = validDate.toISOString().split('T')[0];
    // Verifica a disponibilidade dinâmica (calculada para o mês) PRIMEIRO
    const appointmentCount = availabilityData[formattedDateStringForAvailability];
    if (appointmentCount !== undefined && appointmentCount >= totalSlotsDisponiveis) {
      return 'sem-vagas'; // Marca como sem vagas se estiver cheio dinamicamente
    }

    // Verifica se é o dia da próxima vaga encontrada
    const formattedNextAvailableDate = nextAvailableDate ? nextAvailableDate.toISOString().split('T')[0] : null;
    if (formattedNextAvailableDate && formattedDateStringForAvailability === formattedNextAvailableDate) {
      return 'vaga-proxima';
    }

    return ''; // Retorna uma string vazia por padrão se nenhuma outra condição for atendida
  };

  // Função para filtrar as datas no DatePicker do modal de reagendamento, agora com useCallback
  const filterRescheduleDates = useCallback((date) => {
    // Não permitir domingos
    if (date.getDay() === 0) {
      return false;
    }
    // Não permitir feriados
    if (getFeriadoNome(date)) {
      return false;
    }
    const dateString = date.toISOString().split('T')[0];

    // Não permitir dias sem vagas (baseado nos dados já carregados para o mês)
    const appointmentCount = availabilityData[dateString] || 0;
    if (appointmentCount >= totalSlotsDisponiveis) {
      return false;
    }

    // Se passar por todas as validações, a data é permitida
    return true;
  }, [getFeriadoNome, availabilityData, totalSlotsDisponiveis]);

  // Função para desabilitar datas no calendário principal (domingos e feriados)
  const isTileDisabled = useCallback(({ date, view }) => {
    if (view === 'month') {
      // 1. Desabilita feriados
      if (getFeriadoNome(date)) {
        return true;
      }
      // 2. Desabilita dias bloqueados
      if (isDiaBloqueado(date)) {
        return true;
      }
      // 3. Desabilita dias da semana inativos
      if (agendaHorariosGerados) {
        const diaDaSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][date.getDay()];
        const configDia = agendaHorariosGerados[diaDaSemana];
        if (!configDia || (configDia['Manhã'].length === 0 && configDia['Tarde'].length === 0 && configDia['Noite'].length === 0)) {
          return true;
        }
      }
    }
    return false;
  }, [getFeriadoNome, isDiaBloqueado, agendaHorariosGerados]);

  // useEffect para buscar horários disponíveis no modal de reagendamento
  useEffect(() => {
    if (!showRescheduleModal || !appointmentToReschedule || !currentEntidade) return;

    // Valida a data selecionada ANTES de buscar os horários.
    // Se a data não for válida (feriado, sem vagas, etc.), limpa os slots e interrompe.
    const isDateValid = filterRescheduleDates(newScheduleDate);
    if (!isDateValid) {
      setNewAvailableSlots([]); // Limpa os horários disponíveis
      setSelectedNewTime(null); // Reseta o horário selecionado
      return; // Interrompe a execução do useEffect
    }

    const fetchSlots = async () => {
      setIsLoadingSlots(true);
      try {
        const day = newScheduleDate.getDate().toString().padStart(2, '0');
        const month = (newScheduleDate.getMonth() + 1).toString().padStart(2, '0');
        const year = newScheduleDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        const response = await axios.get(`/api/agendamentos/entidade/${currentEntidade.id}/medico/${appointmentToReschedule.medico_id}/data/${formattedDate}`);

        const existingAppointments = response.data.agendamentos || [];
        const bookedTimes = existingAppointments.map(app => app.hora_marcada.slice(0, 5));

        let allSlots = Object.values(horariosAtendimento).flat();
        let availableSlots = allSlots.filter(slot => !bookedTimes.includes(slot));

        // Filtra horários que já passaram se a data selecionada for hoje
        const today = new Date();
        if (
          newScheduleDate.getDate() === today.getDate() &&
          newScheduleDate.getMonth() === today.getMonth() &&
          newScheduleDate.getFullYear() === today.getFullYear()
        ) {
          const now = new Date();
          const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
          availableSlots = availableSlots.filter(slot => slot > currentTime);
        }


        setNewAvailableSlots(availableSlots);
        setSelectedNewTime(null); // Reseta o horário selecionado quando a data muda
      } catch (error) {
        console.error("Erro ao buscar horários disponíveis para reagendamento:", error);
        setNewAvailableSlots([]);
      } finally {
        setIsLoadingSlots(false);
      }
    };

    fetchSlots();
  }, [newScheduleDate, showRescheduleModal, appointmentToReschedule, currentEntidade, horariosAtendimento, filterRescheduleDates]);

  const handleConfirmReschedule = async () => {
    if (!appointmentToReschedule || !newScheduleDate || !selectedNewTime) {
      showAlertModal('Erro', 'Selecione uma nova data e horário para reagendar.', 'warning');
      return;
    }

    setIsLoadingReschedule(true);
    try {
      const newDateFormatted = newScheduleDate.toISOString().split('T')[0];

      await axios.put(`/api/agendamentos/${appointmentToReschedule.id}`, {
        data_agendamento: newDateFormatted,
        hora_marcada: selectedNewTime,
      });

      showAlertModal('Sucesso', 'Agendamento remarcado com sucesso!', 'success');

      if (onAppointmentStatusChange) { onAppointmentStatusChange(); }
      handleCloseRescheduleModal();
    } catch (error) {
      showAlertModal('Erro', `Falha ao reagendar: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsLoadingReschedule(false);
    }
  };

  // Efeito para filtrar médicos por especialidade (local)
  useEffect(() => {
    const filteredDoctors = selectedEspecialidade
      ? todosMedicos.filter(medico => medico.especialidade_id === parseInt(selectedEspecialidade, 10))
      : todosMedicos; // todosMedicos is a prop
    setLocalMedicos(filteredDoctors); // Updates localMedicos state
    if (!isCurrentUserCorpoClinico) {
      setSelectedMedico('');
    }
  }, [selectedEspecialidade, todosMedicos, isCurrentUserCorpoClinico, setSelectedMedico]);

  // Função para atualizar o estado quando o mês ativo do calendário muda
  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const newDate = activeStartDate;
    setActiveStartDate(currentActiveStateDate => {
      if (newDate.getFullYear() !== currentActiveStateDate.getFullYear() ||
        newDate.getMonth() !== currentActiveStateDate.getMonth()) {
        return newDate;
      }
      return currentActiveStateDate;
    });
  };

  // handleDateChange agora apenas atualiza a data selecionada
  const handleDateChange = (date) => { // Este setter agora é passado via props
    setSelectedDate(date); // Este setter agora é passado via props
  };

  const handleSearchInputChange = (event) => {
    setSelectedEspecialidade('');
    setSelectedMedico('');
    setSearchInput(event.target.value);
  };

  const handleEspecialidadeChange = (event) => { // Este setter agora é passado via props
    // setIsLoadingCalendar(true); // Loading é gerenciado pelo pai 
    setSelectedEspecialidade(event.target.value); // Este setter agora é passado via props
    setSelectedMedico(''); // Este setter agora é passado via props
    setSearchInput('');
  };

  const handleMedicoChange = (event) => { // Este setter agora é passado via props
    setSelectedMedico(event.target.value); // Este setter agora é passado via props
    setNextAvailableDate(null); // Limpa a próxima data ao trocar de médico
    setSearchInput('');
  };

  useEffect(() => { // Uses local states: searchInput, filteredEspecialidades, filteredMedicos, localMedicos
    if (searchInput.length > 2) {
      const searchTerm = searchInput.toLowerCase();
      setFilteredEspecialidades(especialidades.filter(especialidade =>
        especialidade.nome.toLowerCase().includes(searchTerm)
      ));
      setFilteredMedicos(localMedicos.filter(medico => // Use localMedicos here
        medico.nome.toLowerCase().includes(searchTerm)
      ));
    } else {
      setFilteredEspecialidades([]);
      setFilteredMedicos([]);
    }
  }, [searchInput, especialidades, localMedicos]); // Dependency on localMedicos

  const getRowStyle = (appointment) => {
    if (!appointment) return {};

    switch (appointment.status) {
      case 'Faltou':
      case 'Cancelada':
      case 'Desmarcada':
        return { background: '#fd7e14' };
      case 'Realizada':
        return { background: '#6fa48b' };
      case 'Em andamento':
        return { background: '#bbdfa6' };
      default:
        return {};
    }
  };

  // //Cadastro novo agendamento
  // const [newAppointment, setNewAppointment] = useState({ // Local state for the form
  //   entidade_id: currentEntidade ? currentEntidade.id : null, // Usa do contexto (ainda local para o formulário)
  //   filial_id: '', // Usar string vazia
  //   especialidade_id: selectedEspecialidade || '', // Usar string vazia se não selecionado
  //   medico_id: selectedMedico || '', // Usar string vazia se não selecionado
  //   paciente_id: '', // Usar string vazia
  //   data_agendamento: null,
  //   hora_marcada: '', // Usar string vazia
  //   tipo: 'Consulta', // Valor padrão, altere se necessário
  //   status: 'Agendada', // Valor padrão, altere se necessário
  //   interesses: [], // Adicionar campo de interesses
  // });

  // Local states for new appointment modal
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null); // ADDED

  // Atualiza entidade_id no newAppointment quando currentEntidade mudar
  useEffect(() => {
    if (currentEntidade) {
      setNewAppointment(prev => ({ ...prev, entidade_id: currentEntidade.id }));
    }
  }, [currentEntidade]);

  // NOVO: Handler para os dropdowns de especialidade/médico dentro do modal
  const handleModalFormChange = (e) => {
    const { name, value } = e.target;
    setNewAppointment(prev => {
      const newState = { ...prev, [name]: value };
      // Se a especialidade mudou, reseta o médico
      if (name === 'especialidade_id') {
        newState.medico_id = '';
      }
      return newState;
    });
  };

  // Função para lidar com o clique em um horário vazio
  const handleTimeSlotClick = (horario, date, preSelectedMedicoId = null, preSelectedEspecialidadeId = null, isReusing = false) => {
    setIsReusingSlot(isReusing); // Define se é uma reutilização

    const targetMedico = preSelectedMedicoId || selectedMedico;
    const targetEspecialidade = preSelectedEspecialidadeId || selectedEspecialidade;

    // Se não for uma reutilização, mantém a validação original
    if (!isReusing) {
      if (!targetEspecialidade) {
        showAlertModal('Atenção', 'Por favor, selecione uma especialidade antes de agendar.', 'warning'); // selectedEspecialidade é prop
        return; // Impede a abertura do modal
      }
      if (!targetMedico) {
        showAlertModal('Atenção', 'Por favor, selecione um Médico antes de agendar.', 'warning');
        return; // Impede a abertura do modal
      }
    }

    // Validação para não agendar em dias passados, mas permitir no dia atual.
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Zera a hora para comparar apenas o dia

    const selectedDay = new Date(date || selectedDate);
    selectedDay.setHours(0, 0, 0, 0); // Zera a hora para comparar apenas o dia

    if (selectedDay < today) {
      showAlertModal('Horário Inválido', 'Não é possível agendar em um dia que já passou.', 'warning');
      return; // Impede a abertura do modal
    }

    const appointmentExists = calendarAppointments.some(a => 
      a.hora_marcada.slice(0, 5) === horario && 
      !['Cancelada', 'Faltou', 'Desmarcada'].includes(a.status)
    );
    if (!appointmentExists) {
      setSelectedTimeSlot(horario);
      setShowModal(true);
      setSelectedServicos([]); // Limpa os serviços selecionados ao abrir o modal

      // Preenche a data e hora no estado do novo agendamento
      setNewAppointment(prevAppointment => ({
        ...prevAppointment,
        especialidade_id: isReusing ? '' : (targetEspecialidade || ''),
        medico_id: isReusing ? '' : (targetMedico || ''),
        // --- CORREÇÃO: Formata a data manualmente para evitar problemas de fuso horário ---
        data_agendamento: [
          selectedDay.getFullYear(),
          (selectedDay.getMonth() + 1).toString().padStart(2, '0'),
          selectedDay.getDate().toString().padStart(2, '0')
        ].join('-'),
        // --- FIM DA CORREÇÃO ---
        hora_marcada: horario,
        paciente_id: '', // Reseta o paciente_id para string vazia
        interesses: [], // Reseta os interesses
      }));
    }
  };

  const handleFabClick = () => {
    const now = new Date();
    let targetDate = new Date(selectedDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (targetDate < today) {
        targetDate = today;
    }

    let defaultHour = now.getHours() + 1;
    if (targetDate > today) {
        defaultHour = 8;
    }
    
    if (defaultHour < startHour) defaultHour = startHour;
    if (defaultHour > endHour) defaultHour = endHour;

    const formattedTime = `${defaultHour.toString().padStart(2, '0')}:00`;
    handleTimeSlotClick(formattedTime, targetDate);
  };

  // Memo para obter o nome do paciente selecionado
  const selectedPacienteName = useMemo(() => {
    if (newAppointment.paciente_id) {
      const paciente = pacientesList.find(p => p.id === newAppointment.paciente_id);
      return paciente ? paciente.nome : '';
    }
    return '';
  }, [newAppointment.paciente_id, pacientesList]);

  // Efeito para preencher o campo de busca quando um paciente é selecionado (ou o modal é aberto)
  useEffect(() => {
    setPacienteSearch(selectedPacienteName);
  }, [selectedPacienteName]);

  // Memo para filtrar a lista de pacientes com base na busca
  const filteredPacientes = useMemo(() => {
    if (!pacienteSearch) return pacientesList;
    const termoNormalizado = normalizeString(pacienteSearch);
    return pacientesList.filter(paciente => normalizeString(paciente.nome).includes(termoNormalizado));
  }, [pacienteSearch, pacientesList]);

  // Função para lidar com o fechamento do modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTimeSlot(null);
    setIsReusingSlot(false); // Reseta o estado de reutilização
    setSelectedPackageId(null); // Limpa o pacote selecionado ao fechar
  };

  // Memo para criar a lista de opções de interesses, filtrando os que o paciente já possui.
  const filteredInteresseOptions = useMemo(() => {
    // Se nenhum paciente estiver selecionado no modal, não mostra nenhuma opção.
    if (!newAppointment.paciente_id) {
      return []; // Retorna array vazio para não mostrar opções antes de selecionar paciente.
    }
    // Encontra o paciente selecionado na lista completa de pacientes.
    const pacienteSelecionado = pacientesList.find(p => p.id === newAppointment.paciente_id);
  
    // Se o paciente não for encontrado ou não tiver interesses, retorna a lista completa de interesses disponíveis.
    if (!pacienteSelecionado || !pacienteSelecionado.interesses || pacienteSelecionado.interesses.length === 0) {
      return allInteresses;
    }
    const interessesAtuaisIds = new Set(pacienteSelecionado.interesses.map(i => i.id));
    // Filtra a lista de todas as opções, mantendo apenas aquelas cujo ID não está no Set.
    return allInteresses.filter(option => !interessesAtuaisIds.has(option.value));
  }, [allInteresses, newAppointment.paciente_id, pacientesList]);


  // Função para vincular interesses e notificar o pai para atualizar a lista de pacientes.
  const updatePatientInterests = async (pacienteId, novosInteresses) => {
    if (!novosInteresses || novosInteresses.length === 0) {
      return; // Não faz nada se não houver interesses a serem vinculados.
    }
    if (!pacienteId) {
      console.error("ID do paciente não fornecido para vincular interesses.");
      return;
    }

    // Extrai apenas os IDs dos interesses.
    const interessesIds = novosInteresses.map(tag => tag.value);

    try {
      // A nova rota dedicada espera apenas os IDs dos interesses.
      // O backend se encarregará de criar as entradas na tabela 'paciente_interesse'.
      await axios.post(`/api/pacientes/${pacienteId}/interesses`, {
        interesses: interessesIds, // Enviando um objeto JSON com a chave 'interesses'
      });


      // <<<<<<< NOVA LÓGICA >>>>>>>
      // Após o sucesso, chama o callback para atualizar o estado no componente pai.
      if (onPatientInterestsUpdate) {
        onPatientInterestsUpdate(pacienteId, novosInteresses);
      }
    } catch (error) {
      console.error(`Erro ao vincular interesses ao paciente ${pacienteId}:`, error);
      const errorMessage = error.response?.data?.message || 'Não foi possível vincular os interesses ao paciente.';
      showAlertModal('Erro', errorMessage, 'warning');
    }
  };

  // Função para lidar com a criação do agendamento
  const handleCreateAppointment = async () => {
    try {
      // Validação
      if (!newAppointment.paciente_id) {
        showAlertModal('Validação', 'Por favor, selecione um paciente.', 'warning');
        return;
      }
      // Validação de médico e especialidade movida para cá para funcionar com a reutilização
      if (!newAppointment.especialidade_id) {
        showAlertModal('Validação', 'Por favor, selecione uma especialidade.', 'warning');
        return;
      }
      if (!newAppointment.medico_id) {
        showAlertModal('Validação', 'Por favor, selecione um médico.', 'warning');
        return;
      }
      if (!currentEntidade) {
        showAlertModal('Erro', 'Entidade não carregada. Tente novamente.', 'danger');
        return;
      }

      setIsLoadingCreate(true);

      // Garant e que os IDs sejam números ou null antes de enviar para a API
      // CORREÇÃO: Usa os valores do estado newAppointment, que são definidos corretamente ao abrir o modal (inclusive na reutilização)
      const especialidadeIdParaApi = newAppointment.especialidade_id ? parseInt(newAppointment.especialidade_id, 10) : null;
      const medicoIdParaApi = newAppointment.medico_id ? parseInt(newAppointment.medico_id, 10) : null;

      const data = {
        ...newAppointment,
        entidade_id: currentEntidade.id, // Garante que o ID da entidade do contexto seja usado
        servicos: selectedServicos, // Add selected services to request body
        pacote_id: selectedPackageId, // Adiciona o ID do pacote, se houver
      }

      // Remove a chave 'interesses' para não enviar no payload do agendamento
      delete data.interesses;

      data.especialidade_id = especialidadeIdParaApi;
      data.medico_id = medicoIdParaApi;
      // Faz a requisição para a API para criar o agendamento
      const response = await axios.post('/api/agendamentos', data); //Include servicos data in the request

      // Update appointments state directly
      if (response.status === 201) {
        const createdAppointment = response.data.agendamento; // Assuming your API returns the created appointment

        // Após criar o agendamento, atualiza os interesses do paciente
        if (newAppointment.interesses && newAppointment.interesses.length > 0) {
          await updatePatientInterests(newAppointment.paciente_id, newAppointment.interesses);
        }

        // Notifica o pai para atualizar a lista e a disponibilidade
        // O pai será responsável por re-buscar todos os dados (agendamentos do dia, disponibilidade, etc.)
        onAppointmentCreated(createdAppointment);
      }

      // Fecha o modal
      handleCloseModal();

      // fetchAppointments(); 
    } catch (error) {
      // Verifica se o erro é de limite de agendamentos atingido
      if (error.response && error.response.data && error.response.data.action === 'buy_more') {
        const { message } = error.response.data;
        handleCloseModal(); // Fecha o modal de agendamento

        if (currentUserRole === 'Representante Legal') {
          showAlertModal(
            'Limite Atingido',
            message,
            'warning',
            () => navigate('/comprar-creditos') // Redireciona após o usuário fechar o alerta
          );
        } else {
          showAlertModal('Limite Atingido', message, 'warning');
        }
      } else {
        const errorMessage = error.response?.data?.message || 'Erro ao criar agendamento.';
        showAlertModal('Erro', errorMessage, 'danger');
      }
    } finally {
      setIsLoadingCreate(false); // Desativa o indicador de carregamento, independentemente de sucesso ou falha
    }
  };

  // Local state for loading status of individual appointment changes
  const [loadingStatusChanges, setLoadingStatusChanges] = useState({}); // ADDED

  // NOVO: Estado de loading para o botão "Chamar"
  const [loadingChamar, setLoadingChamar] = useState({});

  // NOVO: Estado local para toasts
  const [localToasts, setLocalToasts] = useState([]);

  // NOVO: Função para adicionar um toast local
  const addLocalToast = (title, message, type = 'light') => {
    const id = Date.now();
    setLocalToasts(prev => [...prev, { id, title, message, type }]);
    // Remove o toast após 4 segundos
    setTimeout(() => setLocalToasts(prev => prev.filter(t => t.id !== id)), 4000);
  };

  // NOVO: Função para chamar o paciente no painel
  const handleChamarPaciente = async (agendamentoId) => {
    setLoadingChamar(prev => ({ ...prev, [agendamentoId]: true }));
    try {
      // A API não retorna dados, apenas uma mensagem de sucesso.
      await axios.post(`/api/agendamentos/${agendamentoId}/chamar`);
      addLocalToast('Sucesso', 'Paciente chamado no painel!', 'success');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao chamar o paciente.';
      showAlertModal('Erro', errorMessage, 'danger');
    } finally {
      setLoadingChamar(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };
  
  // NOVO: Componente para renderizar os toasts locais
  const LocalToastManager = () => (
    <ToastContainer
      position="top-end"
      className="p-3"
      style={{ zIndex: 9999 }}
    >
      {localToasts.map((toast) => (
        <Toast
          key={toast.id}
          onClose={() => setLocalToasts(prev => prev.filter(t => t.id !== toast.id))}
          show={true}
          delay={4000}
          autohide
          bg={toast.type.toLowerCase()}
          className="text-white"
        >
          <Toast.Header><strong className="me-auto">{toast.title}</strong></Toast.Header>
          <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );


  const handleStatusChange = async (agendamentoId, newStatus, consultaAtual = null, historicoConsultas = null) => {
    setLoadingStatusChanges(prevLoading => ({ ...prevLoading, [agendamentoId]: true })); // Ativa o loading para o agendamento específico

    try {
      const currentTimeISO = new Date().toISOString(); // Captura a hora atual para consistência
      const response = await axios.put(`/api/agendamentos/${agendamentoId}`, {
        status: newStatus,
      });

      if (response.status === 200) {
        // Notifica o pai para atualizar a lista e o paciente selecionado

        const appointment = fiveDayAppointments.find(a => a.id === agendamentoId);
        const paciente = pacientesList.find(p => p.id === appointment.paciente_id);

        // Se o status mudou para 'Em andamento', atualiza o pacienteSelecionado no contexto
        // Isso também definirá o agendamento_updated_at para o cronômetro
         if (newStatus === 'Em andamento' && paciente && appointment) {
          setPacienteSelecionado({
            ...paciente,
            agendamento_id: agendamentoId,
            agendamento_status: newStatus,
            agendamento_updated_at: currentTimeISO, // Usa a hora capturada
            data_agendamento: appointment.data_agendamento,
            hora_marcada: appointment.hora_marcada,
            servicosDoAgendamento: appointment.servicos || [], // NOVO: Injeta os serviços do agendamento no contexto
            consultaAtual: consultaAtual, // Injeta a consulta atual no contexto
            historico: historicoConsultas, // Injeta o histórico de consultas no contexto
          });
        }
        // Notifica o pai sobre a mudança de status para que ele possa re-buscar os dados.
        // Isso é feito para qualquer mudança de status, não apenas 'Em andamento'.
        onAppointmentStatusChange(response.data.agendamento); // Passa o agendamento atualizado

      } else {
        const errorMsg = response.data?.message || 'Erro ao atualizar o status do agendamento.'; // Usar 'response' aqui
        showAlertModal('Erro de Conexão', errorMsg, 'danger');
      }
    } catch (error) {
      console.error('Erro ao atualizar o status do agendamento:', error);
    } finally {
      setLoadingStatusChanges(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // Desativa o loading para o agendamento específico
    }
  };

  // --- NOVOS ESTADOS PARA O MODAL DE ALTERAÇÃO DE PROFISSIONAL ---
  const [showChangeProfModal, setShowChangeProfModal] = useState(false);
  const [appointmentToChangeProf, setAppointmentToChangeProf] = useState(null);
  const [newProfessionalId, setNewProfessionalId] = useState('');
  const [isUpdatingProfessional, setIsUpdatingProfessional] = useState(false);

  const [changeProfError, setChangeProfError] = useState(null); // Para a mensagem de erro
  const [availableDoctors, setAvailableDoctors] = useState([]); // Para a lista de médicos disponíveis
  // Função auxiliar para calcular a duração da consulta no formato 'HH:mm:ss'
  function calcularDuracao(startTime, endTime) {
    if (!startTime || !endTime) return '00:00:00';
    const diffMs = endTime - startTime;
    if (diffMs < 0) return '00:00:00'; // Evita duração negativa
    const diffSecs = Math.round(diffMs / 1000);
    const hours = Math.floor(diffSecs / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((diffSecs % 3600) / 60).toString().padStart(2, '0');
    const seconds = Math.floor((diffSecs % 60)).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  // Local state for loading status of individual appointment finalization
  const [loadingFinalizarAgenda, setLoadingFinalizarAgenda] = useState({}); // ADDED

  // Função para finalizar consulta diretamente da tela de Agendas
  const handleFinalizarConsultaAgenda = async (agendamentoId) => {
    const appointment = calendarAppointments.find(a => a.id === agendamentoId); // calendarAppointments
    if (!currentEntidade) {
      showAlertModal('Erro', 'Entidade não carregada.', 'danger');
      return;
    }
    if (!appointment || !appointment.updated_at) {
      showAlertModal('Erro Interno', 'Agendamento ou hora de início não encontrados para finalizar.', 'danger');
      return;
    }

    setLoadingFinalizarAgenda(prevLoading => ({ ...prevLoading, [agendamentoId]: true }));
    let duration; // Declare duration here, outside the try block

    try {
      const startTime = new Date(appointment.updated_at); // Usa o updated_at que foi setado ao iniciar
      const endTime = new Date();
      duration = calcularDuracao(startTime, endTime); // Assign value to the already declared variable

      const response = await axios.put(
        `/api/agendamentos/${agendamentoId}`,
        { status: 'Realizada', duracao_atendimento: duration }
      );

      if (response.status === 200) {
        console.log('Agendamento finalizado com sucesso pela Agenda!');
      } else {
        showAlertModal('Erro', `Erro ao finalizar o agendamento: ${response.data?.message || 'Resposta inesperada.'}`, 'danger');

      }
    } catch (error) {
      showAlertModal('Erro de Conexão', `Erro ao finalizar o agendamento: ${error.response?.data?.message || error.message}`, 'danger');

      onAppointmentFinalized(agendamentoId, 'Realizada', duration); // Notifica o pai para re-fetch
    } finally {
      setLoadingFinalizarAgenda(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
    }
  };

  // Função auxiliar para navegar para o prontuário (extraída do antigo handleRowClick)
  const handleGoToProntuario = (appointment) => {
    if (appointment && appointment.status === 'Em andamento') {
      // Busca dados do paciente (pacientesList)
      const pacienteParaContexto = pacientesList.find(p => p.id === appointment.paciente_id);
      if (pacienteParaContexto) {
        // Adiciona informações do agendamento ao paciente antes de enviar para o contexto
        pacienteParaContexto.agendamento_id = appointment.id;
        pacienteParaContexto.agendamento_status = appointment.status;
        pacienteParaContexto.agendamento_updated_at = appointment.updated_at; // This is used by the timer in Consultorio.js
        pacienteParaContexto.data_agendamento = appointment.data_agendamento; // Adiciona data
        pacienteParaContexto.hora_marcada = appointment.hora_marcada; // Adiciona hora

        // Cria um NOVO objeto usando spread syntax para garantir que a referência mude
        // Isso força o useEffect no Consultorio a rodar novamente
        setPacienteSelecionado({ ...pacienteParaContexto });
      }
    }
  };

  const handleRowClick = (appointment) => {
    // Agora, ao clicar, apenas seleciona o agendamento para mostrar na sidebar
    setSelectedSidebarAppointment(appointment);
    // Simula a abertura do menu lateral (hamburguer) em mobile/tablet para ver detalhes
    if (!isDesktop) {
        setIsSidebarOpen(true);
    }
  };

  // Função para buscar e abrir o histórico de pacotes
  const handleOpenPackageHistory = async () => {
    if (!selectedSidebarAppointment?.paciente_id) return;
    
    setIsLoadingPackageHistory(true);
    setShowPackageHistoryModal(true);
    try {
        const response = await axios.get(`/api/pacientes/${selectedSidebarAppointment.paciente_id}/pacotes-com-historico`);
        setPackageHistoryData(response.data.pacotes_historico || []);
    } catch (error) {
        console.error("Erro ao buscar histórico de pacotes:", error);
        setPackageHistoryData([]);
    } finally {
        setIsLoadingPackageHistory(false);
    }
  };

  // Função para retomar um atendimento já realizado ou em pagamento
  const handleRetomarAtendimento = async (agendamentoId) => {
    setLoadingStatusChanges(prev => ({ ...prev, [agendamentoId]: true }));
    try {
        // 1. Busca a consulta vinculada ao agendamento para preencher o prontuário
        const { data } = await axios.get(`/api/consultas/agendamento/${agendamentoId}`);
        const consultaAtual = data.consulta;

        // 2. Busca o histórico do paciente (para manter consistência com o fluxo de iniciar consulta)
        const agendamento = fiveDayAppointments.find(a => a.id === agendamentoId);
        let historicoConsultas = [];
        if (agendamento?.paciente_id) {
            const histRes = await axios.get(`/api/pacientes/${agendamento.paciente_id}/consultas`);
            historicoConsultas = histRes.data.paciente?.consultas || [];
        }

        // 3. Chama a mudança de status passando a consulta recuperada
        // Isso garante que o Prontuario.js receba os dados preenchidos imediatamente
        await handleStatusChange(agendamentoId, 'Em andamento', consultaAtual, historicoConsultas);

    } catch (error) {
        console.error("Erro ao retomar atendimento:", error);
        showAlertModal('Erro', 'Falha ao carregar dados do atendimento anterior. Verifique se a consulta foi criada corretamente.', 'danger');
        setLoadingStatusChanges(prev => ({ ...prev, [agendamentoId]: false }));
    }
  };

  const handleIniciarConsulta = async (agendamentoId) => {
    setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: true }));
    if (!currentEntidade) {
      showAlertModal('Erro', 'Entidade não carregada.', 'danger');
      setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
      return;
    }
    try {
      const agendamento = fiveDayAppointments.find(a => a.id === agendamentoId);

      if (!agendamento) {
        console.error('Agendamento não encontrado!'); // calendarAppointments is a prop
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
        return;
      }

      // *** NOVA VERIFICAÇÃO GLOBAL VIA API ***
      // Verifica se o médico LOGADO (currentUser.id) já tem consulta em andamento
      if (!currentUser || !currentUser.id) {
        showAlertModal('Erro', 'ID do funcionário logado não disponível.', 'danger');
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false }));
        return;
      }
      const checkResponse = await axios.get(`/api/medicos/${currentUser.id}/consulta-em-andamento`);


      if (checkResponse.data.inProgress && checkResponse.data.dataAgendamento) {
        showAlertModal('Consulta em Andamento', 'Você já possui uma consulta em andamento. A agenda será direcionada para o dia da consulta ativa.', 'info'); // calendarAppointments
        setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // Reseta o loading // calendarAppointments

        // Converte a data YYYY-MM-DD para um objeto Date e define no calendário
        const ongoingDate = new Date(checkResponse.data.dataAgendamento + 'T00:00:00'); // Adiciona T00:00:00 para evitar problemas de timezone
        setSelectedDate(ongoingDate); // Navega o calendário para a data

        return; // Impede o início da nova consulta
      }

      // Criar objeto de dados da consulta
      const consultaData = { 
        paciente_id: agendamento.paciente_id, 
        agendamento_id: agendamento.id, 
        data_consulta: agendamento.data_agendamento, 
        entidade_id: currentEntidade.id,
        prontuario_id: agendamento.paciente?.prontuario_id // Envia o prontuario_id se disponível
      };

      // >>> INÍCIO DA ALTERAÇÃO <<<
      // Garante que temos os dados completos do agendamento, incluindo os serviços.
      let agendamentoCompleto = agendamento;
      if (typeof agendamento.servicos === 'undefined') {
        try {
          const agendamentoResponse = await axios.get(`/api/agendamentos/${agendamento.id}`);
          agendamentoCompleto = agendamentoResponse.data; // Sobrescreve com os dados completos
        } catch (fetchError) {
          console.error("Falha ao buscar detalhes do agendamento:", fetchError);
          showAlertModal('Erro', 'Não foi possível carregar os detalhes dos serviços do agendamento.', 'danger');
          return; // Interrompe a execução se não conseguir buscar os serviços
        }
      }



      // 1. Fazer a requisição para criar a consulta
      const consultaResponse = await axios.post('/api/consultas', consultaData);

      if (consultaResponse.status === 201 && agendamentoCompleto) {
        // Otimização: Busca o histórico do paciente aqui para injetar no contexto
        const historicoResponse = await axios.get(`/api/pacientes/${agendamentoCompleto.paciente_id}/consultas`);
        const historicoConsultas = historicoResponse.data.paciente?.consultas || [];

        // >>> INÍCIO DA ALTERAÇÃO <<<
        // Injeta os serviços do agendamento original na consulta recém-criada

        const consultaComServicos = {
          ...consultaResponse.data.consulta,
          agendamento: { servicos: agendamentoCompleto.servicos || [] }
        };

        // 2. Chamar handleStatusChange para atualizar o status do agendamento para 'Em andamento'
        await handleStatusChange(agendamentoId, 'Em andamento', consultaComServicos, historicoConsultas);


      } else {
        var _consultaResponse$dat;
        showAlertModal('Erro', `Erro ao criar a consulta: ${((_consultaResponse$dat = consultaResponse.data) === null || _consultaResponse$dat === void 0 ? void 0 : _consultaResponse$dat.message) || 'Resposta inesperada.'}`, 'danger');

      }

    } catch (error) {
      showAlertModal('Erro de Conexão', `Erro ao iniciar a consulta: ${error.response?.data?.message || error.message}`, 'danger');

      // Lidar com o erro (exibir mensagem para o usuário, etc.)
    } finally {
      setLoadingIniciarConsulta(prevLoading => ({ ...prevLoading, [agendamentoId]: false })); // calendarAppointments
    } // calendarAppointments is a prop
  };

  const handleOpenPaymentModal = (appointment) => {
    setSelectedAppointmentForPayment(appointment);
    setShowPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedAppointmentForPayment(null);
  };

  const handlePaymentConfirmation = (agendamentoAtualizado) => {
    // CORREÇÃO: Recebe o objeto `agendamento` completo e atualizado do PaymentModal
    // e o repassa para o callback do componente pai (`Consultorio.js`).
    onAppointmentStatusChange(agendamentoAtualizado);
  };

  // Função para abrir o modal de comunicação, com validação prévia
  const handleOpenCommunicationModal = () => {
    if (currentEntidade && currentEntidade.email_config_complete) {
      setShowCommunicationModal(true);
    } else {
        showAlertModal(
            'Configuração de E-mail Pendente',
            'As configurações de envio de e-mail (SMTP) não foram realizadas. Isso é necessário para enviar comunicados. Clique em OK para configurar agora.',
            'warning',
            () => navigate('/configuracoes') // Redireciona para a página de configurações
        );
    }
  };

    // NOVO: Handler para abrir o modal de cancelamento de pagamento
  const handleOpenCancelPaymentModal = (appointment) => {
    setAppointmentToCancelPayment(appointment);
    setShowCancelPaymentModal(true);
  };

  // NOVO: Handler para confirmar e executar o cancelamento do pagamento
  const handleConfirmCancelPayment = async () => {
    if (!appointmentToCancelPayment) return;

    setIsCancelingPayment(true);
    try {
      // NOVA LÓGICA: Chama o endpoint de cancelamento do agendamento, que cancelará todos os pagamentos associados.
      await axios.post(`/api/agendamentos/${appointmentToCancelPayment.id}/cancel-payments`);
      showAlertModal('Sucesso', 'Pagamento cancelado e estornado com sucesso!', 'success');
      onAppointmentStatusChange(); // Força o refresh da lista de agendamentos
      setShowCancelPaymentModal(false);
    } catch (error) {
      showAlertModal('Erro', `Falha ao cancelar pagamento: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsCancelingPayment(false);
    }
  };

  // NOVO: Handlers para o modal de detalhes do pagamento
  const handleOpenPaymentDetailsModal = (appointment) => {
    // Garante que paymentData seja sempre um array com todos os pagamentos
    let paymentData = appointment.pagamento;
    if (!Array.isArray(paymentData)) {
        paymentData = paymentData ? [paymentData] : [];
    }
    
    setSelectedPaymentDetails(paymentData);
    setSelectedAppointmentForDetails(appointment);
    setShowPaymentDetailsModal(true);
  };

  const handleClosePaymentDetailsModal = () => {
    setShowPaymentDetailsModal(false);
    setSelectedPaymentDetails(null);
    setSelectedAppointmentForDetails(null);
  };
  
  // --- NOVOS HANDLERS PARA ADICIONAR COMISSÃO ---
  const handleStartAddCommission = (paymentId, serviceId) => {
      setEditingCommission({ paymentId, serviceId });
      setSelectedProfessionalForCommission('');
      
      // Define o percentual padrão com base no serviço
      const serviceDef = servicos.find(s => s.id === serviceId);
      if (serviceDef) {
          setCommissionPercentage(serviceDef.percentual_comissao || 0);
      } else {
          setCommissionPercentage(0);
      }
  };

  const handleCancelAddCommission = () => {
      setEditingCommission({ paymentId: null, serviceId: null });
      setSelectedProfessionalForCommission('');
      setCommissionPercentage('');
  };

  const handleSaveCommission = async (paymentId, serviceId) => {
      if (!selectedProfessionalForCommission) {
           showAlertModal('Atenção', 'Selecione um profissional.', 'warning');
           return;
      }
      
      setIsAddingCommission(true);
      try {
          await axios.post(`/api/pagamentos/${paymentId}/servicos/${serviceId}/comissao`, {
              funcionario_id: selectedProfessionalForCommission,
              percentual_comissao: commissionPercentage
          });
          
          showAlertModal('Sucesso', 'Comissão atribuída com sucesso!', 'success');
          handleCancelAddCommission();
          handleClosePaymentDetailsModal();
          if (onAppointmentStatusChange) onAppointmentStatusChange(); // Atualiza a agenda
  
      } catch (error) {
          console.error("Erro ao adicionar comissão:", error);
          showAlertModal('Erro', `Falha ao adicionar comissão: ${error.response?.data?.message || error.message}`, 'danger');
      } finally {
          setIsAddingCommission(false);
      }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  // Rola automaticamente para as 08:00 ao abrir a agenda
  useEffect(() => {
    if (scrollRef.current) {
        const hourToScroll = 8; // Horário foco inicial
        if (hourToScroll > startHour) {
            // 120px é a altura do slot que configuramos anteriormente
            scrollRef.current.scrollTop = (hourToScroll - startHour) * 120;
        }
    }
  }, [startHour]); // Adicionado dependência

  // Fecha o menu de contexto ao clicar fora
  useEffect(() => {
    const handleClick = () => setContextMenu(null);
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  const handleContextMenu = (e, appointment) => {
    e.preventDefault();
    e.stopPropagation(); // Impede que o evento suba
    setContextMenu({
        x: e.clientX,
        y: e.clientY,
        appointment
    });
  };

  // Helper to generate dates for header/grid based on viewMode
  const getVisibleDays = useCallback(() => {
    const days = [];
    const current = new Date(selectedDate);
    current.setHours(0, 0, 0, 0);

    if (viewMode === 'day') {
        days.push(new Date(current));
    } else if (viewMode === 'week') {
        const day = current.getDay(); // 0 (Sun) to 6 (Sat)
        const diff = current.getDate() - day; // Adjust to Sunday
        const start = new Date(current);
        start.setDate(diff);
        for (let i = 0; i < 7; i++) {
            const d = new Date(start);
            d.setDate(d.getDate() + i);
            days.push(d);
        }
    } else if (viewMode === 'month') {
        const year = current.getFullYear();
        const month = current.getMonth();
        const startMonth = new Date(year, month, 1);
        const endMonth = new Date(year, month + 1, 0);
        
        const iter = new Date(startMonth);
        while (iter <= endMonth) {
            days.push(new Date(iter));
            iter.setDate(iter.getDate() + 1);
        }
    }
    return days;
  }, [selectedDate, viewMode]);

  // Fetch appointments based on visible days
  useEffect(() => {
    const fetchAppointmentsForView = async () => {
        if (!currentEntidade) return;
        setLoadingFiveDays(true);
        try {
            const days = getVisibleDays();
            if (days.length === 0) return;
            
            const start = days[0];
            const end = days[days.length - 1];
            
            const startStr = start.toISOString().split('T')[0];
            const endStr = end.toISOString().split('T')[0];

            let url = `/api/agendamentos/entidade/${currentEntidade.id}`;
            if (selectedMedico) {
                url += `/medico/${selectedMedico}`;
            }
            url += `/periodo?inicio=${startStr}&fim=${endStr}`;

            const response = await axios.get(url);
            setFiveDayAppointments(response.data.agendamentos || []);
            // --- NOVO: Converte a duração de HH:mm:ss para minutos ---
            const appointmentsWithDuration = (response.data.agendamentos || []).map(app => {
                let durationInMinutes = 30; // Duração padrão de 30 minutos
                const duracao = app.duracao_agendamento || app.duracao_atendimento;
                if (duracao) {
                    const [h, m] = duracao.split(':').map(Number);
                    durationInMinutes = (h * 60) + m;
                }
                return { ...app, duration: durationInMinutes };
            });

            setFiveDayAppointments(appointmentsWithDuration);
        } catch (e) {
            console.error("Erro ao buscar agendamentos:", e);
        } finally {
            setLoadingFiveDays(false);
        }
    };
    fetchAppointmentsForView();
  }, [selectedDate, selectedMedico, currentEntidade, onAppointmentStatusChange, getVisibleDays, refreshKey]); // Adicionado refreshKey

// Update red line position
  useEffect(() => {
    const updateRedLine = () => {
        const now = new Date();
        // const startHour = 2; // Usando a constante definida no escopo do componente
        const hours = now.getHours();
        const minutes = now.getMinutes();
        if (hours >= startHour && hours <= endHour) {
            const top = ((hours - startHour) * 120) + (minutes * 2); // 120px per hour
            setRedLineTop(top);
        } else {
            setRedLineTop(-1); // Hide
        }
    };
    updateRedLine();
    const interval = setInterval(updateRedLine, 60000);
    return () => clearInterval(interval);
  }, [startHour, endHour]); // Adicionado dependências

  // NOVO: Efeito para gerenciar o redimensionamento (mousemove/mouseup globais)
  useEffect(() => {
    const handleMouseMove = (e) => {
        if (!resizeState) return;
        const deltaY = e.clientY - resizeState.startY;
        // Altura mínima de 30px (15 minutos)
        const newHeight = Math.max(30, resizeState.startHeight + deltaY);
        setResizeState(prev => ({ ...prev, currentHeight: newHeight }));
    };

    const handleMouseUp = async () => {
        if (!resizeState) return;
        const newDurationInMinutes = Math.round(resizeState.currentHeight / 2);
        const snappedDuration = Math.round(newDurationInMinutes / 5) * 5;
        
        // Atualização otimista da UI
        setFiveDayAppointments(prev => prev.map(app => 
            app.id === resizeState.id ? { ...app, duration: snappedDuration } : app
        ));
        
        // Converte minutos para o formato HH:mm:ss para o backend
        const hours = Math.floor(snappedDuration / 60).toString().padStart(2, '0');
        const minutes = (snappedDuration % 60).toString().padStart(2, '0');
        const durationString = `${hours}:${minutes}:00`;

        try {
            await axios.put(`/api/agendamentos/${resizeState.id}`, {
                duracao_agendamento: durationString
            });
        } catch (error) {
            console.error("Erro ao atualizar a duração do agendamento:", error);
            showAlertModal('Erro', 'Não foi possível salvar a nova duração do agendamento.', 'danger');
            // A UI reverterá na próxima atualização de dados, o que é aceitável.
        }
        setResizeState(null);
    };

    if (resizeState) {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [resizeState]);

  // NOVO: Handlers para Drag and Drop
  const handleDragStart = (e, appointment) => {
      // Validação de segurança: Impede arrastar se o status não permitir
      if (['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status)) {
          e.preventDefault();
          addLocalToast('Ação Bloqueada', 'Este agendamento não pode ser movido.', 'warning');
          return;
      }

      setDraggedAppointment(appointment);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', appointment.id);
      // Reduz opacidade visualmente durante o arrasto
      e.target.style.opacity = '0.5';
  };

  const handleDragEnd = (e) => {
      e.target.style.opacity = '1';
      setDraggedAppointment(null);
  };

  const handleDragOver = (e) => {
      e.preventDefault(); // Necessário para permitir o drop
      e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = async (e, targetDate, targetTime) => {
      e.preventDefault();
      if (!draggedAppointment) return;

      // Validação de segurança no drop
      if (['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(draggedAppointment.status)) {
          setDraggedAppointment(null);
          return;
      }

      const newDateStr = targetDate.toISOString().split('T')[0];
      
      // Verifica se houve mudança
      if (draggedAppointment.data_agendamento === newDateStr && 
          draggedAppointment.hora_marcada.slice(0, 5) === targetTime) {
          return;
      }

      // Atualização Otimista
      const originalAppointments = [...fiveDayAppointments];
      setFiveDayAppointments(prev => prev.map(app => {
          if (app.id === draggedAppointment.id) {
              return { ...app, data_agendamento: newDateStr, hora_marcada: targetTime };
          }
          return app;
      }));

      try {
          await axios.put(`/api/agendamentos/${draggedAppointment.id}`, {
              data_agendamento: newDateStr,
              hora_marcada: targetTime,
          });
          
          if (onAppointmentStatusChange) onAppointmentStatusChange();
      } catch (error) {
          console.error("Falha ao reagendar", error);
          setFiveDayAppointments(originalAppointments); // Reverte em caso de erro
          showAlertModal('Erro', 'Falha ao reagendar o compromisso.', 'danger');
      }
  };

  // Helper to generate time slots
  const timeSlots = useMemo(() => {
      const slots = [];
      for (let h = startHour; h <= endHour; h++) {
          for (let m = 0; m < 60; m += slotInterval) {
              slots.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
          }
      }
      return slots;
  }, [startHour, endHour, slotInterval]);

  const styles = {
    container: { display: 'flex', height: 'calc(100vh - 200px)', overflow: 'hidden' },
    sidebar: { 
        width: isDesktop ? '320px' : '280px', 
        minWidth: isDesktop ? '320px' : '280px', 
        borderRight: '1px solid #dee2e6', padding: '1rem', overflowY: 'auto', backgroundColor: '#fff', display: 'flex', flexDirection: 'column',
        position: isDesktop ? 'relative' : 'absolute', zIndex: 1040, height: '100%', transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-110%)', transition: 'transform 0.3s ease-in-out', boxShadow: !isDesktop && isSidebarOpen ? '2px 0 5px rgba(0,0,0,0.2)' : 'none'
    },
    main: { flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: '#f8f9fa' },
    header: { display: 'flex', borderBottom: '1px solid #dee2e6', backgroundColor: '#fff' },
    headerCell: { flex: 1, padding: '10px', textAlign: 'center', borderRight: '1px solid #f0f0f0', fontWeight: 'bold' },
    body: { flexGrow: 1, overflowY: 'auto', position: 'relative', display: 'flex' },
    timeColumn: { width: '60px', minWidth: '60px', borderRight: '1px solid #dee2e6', backgroundColor: '#fff' },
    timeSlot: { height: `${slotInterval * 2}px`, borderBottom: '1px solid #dee2e6', padding: '5px', fontSize: '12px', color: '#888', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    daySlot: { height: `${slotInterval * 2}px`, borderBottom: '1px solid #dee2e6', boxSizing: 'border-box', position: 'relative' },
    dayColumn: { flex: 1, borderRight: '1px solid #f0f0f0', position: 'relative', minWidth: isMobile ? '60px' : '150px' },
    monthCell: { flex: 1, minHeight: '100px', borderRight: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0', padding: '5px', cursor: 'pointer', backgroundColor: '#fff' },
    redLine: { position: 'absolute', height: '2px', backgroundColor: 'red', width: '100%', zIndex: 10, pointerEvents: 'none' },
    redDot: { position: 'absolute', left: '-5px', top: '-4px', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: 'red' },
    card: { position: 'absolute', width: '100%', left: '1%', zIndex: 5, fontSize: '11px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', cursor: 'pointer', overflow: 'hidden', minHeight: '50px', borderRadius: 0 },
    fab: { position: 'fixed', bottom: '20px', right: '20px', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 6px rgba(0,0,0,0.3)', zIndex: 1050 },
    contextMenu: { position: 'fixed', zIndex: 9999, backgroundColor: '#fff', border: '1px solid rgba(0,0,0,.15)', borderRadius: '0.25rem', boxShadow: '0 0.5rem 1rem rgba(0,0,0,.175)', padding: '0.5rem 0', minWidth: '160px' }
  };

  // Função para detectar conflitos de horário no dia
  const getConflicts = (appointments) => {
    const conflicts = new Set();
    const times = appointments.map(app => {
        const [h, m] = app.hora_marcada.split(':').map(Number);
        const start = h * 60 + m;
        // Se estiver redimensionando este agendamento, calcula a duração baseada na altura atual
        let duration = app.duration || 30;
        if (resizeState && resizeState.id === app.id) {
            duration = Math.round(resizeState.currentHeight / 2);
        }
        return { id: app.id, start, end: start + duration };
    });

    for (let i = 0; i < times.length; i++) {
        for (let j = i + 1; j < times.length; j++) {
            const t1 = times[i];
            const t2 = times[j];
            if (t1.start < t2.end && t2.start < t1.end) {
                conflicts.add(t1.id);
                conflicts.add(t2.id);
            }
        }
    }
    return conflicts;
  };

  // --- NOVO: Função para calcular o layout dos eventos (colunas e largura) ---
  const calculateEventLayout = useCallback((appointments) => {
    if (!appointments || appointments.length === 0) return {};

    // 1. Prepara eventos com início/fim em minutos
    const events = appointments.map(app => {
        const [h, m] = app.hora_marcada.split(':').map(Number);
        const start = h * 60 + m;
        let duration = app.duration || 30;
        // Considera o redimensionamento em tempo real
        if (resizeState && resizeState.id === app.id) {
            duration = Math.round(resizeState.currentHeight / 2);
        }
        return { ...app, start, end: start + duration };
    });

    // 2. Ordena por horário de início, depois por duração (maior primeiro)
    events.sort((a, b) => a.start - b.start || b.end - a.end);

    const columns = [];
    
    // 3. Empacota em colunas (First Fit)
    events.forEach(event => {
        let placed = false;
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];
            const lastEventInCol = col[col.length - 1];
            if (event.start >= lastEventInCol.end) {
                col.push(event);
                event.colIndex = i;
                placed = true;
                break;
            }
        }
        if (!placed) {
            columns.push([event]);
            event.colIndex = columns.length - 1;
        }
    });

    // 4. Agrupa eventos sobrepostos
    const eventToGroup = new Map();
    const groups = [];
    
    events.forEach(e => {
        if (eventToGroup.has(e.id)) return;
        
        const group = { events: [], cols: new Set() };
        const queue = [e];
        eventToGroup.set(e.id, group);
        group.events.push(e);
        group.cols.add(e.colIndex);
        
        let head = 0;
        while(head < queue.length) {
            const current = queue[head++];
            // Encontra eventos sobrepostos na lista completa
            events.forEach(other => {
                if (eventToGroup.has(other.id)) return;
                // Verifica sobreposição
                if (current.start < other.end && current.end > other.start) {
                    eventToGroup.set(other.id, group);
                    group.events.push(other);
                    group.cols.add(other.colIndex);
                    queue.push(other);
                }
            });
        }
        groups.push(group);
    });

    const layout = {};
    
    // 5. Calcula largura e posição esquerda para cada grupo
    groups.forEach(group => {
        const numCols = group.cols.size;
        const width = 100 / numCols;
        group.events.forEach(ev => {
            layout[ev.id] = {
                width: `${width}%`,
                left: `${ev.colIndex * width}%`,
                zIndex: ev.colIndex
            };
        });
    });
    
    return layout;
  }, [resizeState]);


  // Função auxiliar para renderizar os filtros (Desktop vs Mobile)
  const renderFilters = (isMobileLayout) => (
      <div className={isMobileLayout ? "d-flex justify-content-between align-items-center p-2 bg-white border-bottom shadow-sm" : "position-absolute top-0 end-0 mt-2 me-3 d-flex align-items-center gap-2"} style={isMobileLayout ? {} : { zIndex: 10 }}>
          <Form.Check 
              type="switch"
              id={`filter-pending-payment-card-${isMobileLayout ? 'mobile' : 'desktop'}`}
              label={isMobile ? "Aguardando Pg." : "Aguardando Pagamento"}
              checked={showOnlyPendingPayment}
              onChange={(e) => setShowOnlyPendingPayment(e.target.checked)}
              className={isMobileLayout ? "mb-0" : "me-3"}
              style={{ fontSize: '0.9rem' }}
          />
          <div className="d-flex align-items-center gap-2">
              {isMobile ? (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Ir para Hoje</Tooltip>}>
                      <Button variant="outline-primary" size="sm" className="bg-blue shadow-sm position-relative" onClick={handleGoToToday}>
                          Hj
                          {selectedDate.toDateString() !== new Date().toDateString() && (
                              <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                  <span className="visually-hidden">Data diferente</span>
                              </span>
                          )}
                      </Button>
                  </OverlayTrigger>
              ) : (
                  <Button variant="outline-primary" size="sm" className={isMobileLayout ? "bg-blue shadow-sm position-relative" : "me-2 bg-blue shadow-sm position-relative"} onClick={handleGoToToday}>
                      Hoje
                      {selectedDate.toDateString() !== new Date().toDateString() && (
                          <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="today-indicator-tooltip">A data atual não está selecionada</Tooltip>}
                          >
                              <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                  <span className="visually-hidden">Data diferente</span>
                              </span>
                          </OverlayTrigger>
                      )}
                  </Button>
              )}

              <ButtonGroup size="sm" className="bg-white shadow-sm">
                  {isMobile ? (
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>Visualização Diária</Tooltip>}>
                          <Button variant={viewMode === 'day' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('day')}>D</Button>
                      </OverlayTrigger>
                  ) : (
                      <Button variant={viewMode === 'day' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('day')}>Dia</Button>
                  )}
                  
                  {isMobile ? (
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>Visualização Semanal</Tooltip>}>
                          <Button variant={viewMode === 'week' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('week')}>S</Button>
                      </OverlayTrigger>
                  ) : (
                      <Button variant={viewMode === 'week' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('week')}>Semana</Button>
                  )}

                  {isDesktop && <Button variant={viewMode === 'month' ? 'primary' : 'outline-primary'} onClick={() => setViewMode('month')}>Mês</Button>}
              </ButtonGroup>
          </div>
      </div>
  );

  // Função auxiliar para renderizar os botões de ação
  const renderActionButtons = (appointment) => {
    const isDayView = viewMode === 'day';
    const btnStyle = { 
        fontSize: isDayView ? '0.9rem' : '0.7rem', 
        padding: isDayView ? '5px 10px' : '2px 5px',
        backgroundColor: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease'
    };

    return (
        <div className="d-flex gap-1 flex-wrap justify-content-end" style={{ pointerEvents: 'auto' }}>
            {/* Check-in */}
            {appointment.status === 'Agendada' && !appointment.hora_chegada && (
                <Button variant="outline-info" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleCheckIn(appointment.id); }} disabled={loadingCheckIn[appointment.id]} title="Fazer Check-in">
                    {loadingCheckIn[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faCheck} />}
                </Button>
            )}

            {/* Chamar Paciente */}
            {isCurrentUserCorpoClinico && appointment.medico_id === currentUser?.id && appointment.status === 'Agendada' && appointment.hora_chegada && (
                  <Button variant="outline-primary" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleChamarPaciente(appointment.id); }} disabled={loadingChamar[appointment.id]} title="Chamar Painel">
                    {loadingChamar[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faBullhorn} />}
                </Button>
            )}

            {/* Iniciar Consulta */}
            {isCurrentUserCorpoClinico && appointment.medico_id === currentUser?.id && appointment.status === 'Agendada' && (
                <Button variant={appointment.hora_chegada ? "outline-success" : "outline-secondary"} size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleIniciarConsulta(appointment.id); }} disabled={loadingIniciarConsulta[appointment.id] || !appointment.hora_chegada} title="Iniciar Consulta">
                    {loadingIniciarConsulta[appointment.id] ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faStethoscope} />}
                </Button>
            )}

            {/* Pagamento */}
            {/* Show only in month view because in day/week view it is handled by the ribbon */}
            {viewMode === 'month' && (((appointment.status === 'Agendada' || appointment.status === 'Realizada') && appointment.payment_status === 'Aguardando Pagamento') ||
              ((appointment.payment_status === 'Pago' || appointment.payment_status === 'Aguardando Pagamento') && appointment.status === 'Aguardando Pagamento')) && (
                canShowPayButton && (
                    <Button variant="outline-danger" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleOpenPaymentModal(appointment); }} title="Receber Pagamento">
                        <FontAwesomeIcon icon={faDollarSign} />
                    </Button>
                )
            )}

             {/* Cancelar Pagamento */}
             {appointment.payment_status === 'Pago' && canShowCancelPayButton && 
                ((appointment.servicos?.length || 0) > 1 || !appointment.paciente_pacote_id || appointment.pagamento?.length > 0) && (
                <Button variant="outline-warning" size="sm" style={btnStyle} className="action-btn-hover" onClick={(e) => { e.stopPropagation(); handleOpenCancelPaymentModal(appointment); }} title="Cancelar Pagamento">
                    <FontAwesomeIcon icon={faBan} />
                </Button>
            )}
        </div>
    );
  };

  const renderEvent = (appointment, hasConflict, layoutStyle, dayDate) => {
    const [h, m] = appointment.hora_marcada.split(':').map(Number);
    // const startHour = 2; // Usando a constante definida no escopo do componente
    const top = ((h - startHour) * 120) + (m * 2);
    const colors = getStatusColors(appointment.status);
    
    // Lógica de redimensionamento
    const isResizing = resizeState && resizeState.id === appointment.id;
    const duration = appointment.duration || 30; // Duração padrão de 30 min se não houver
    const height = isResizing ? resizeState.currentHeight : duration * 2;
    const isHovered = hoveredAppointmentId === appointment.id;
    
    // Verifica status de pagamento para exibir a fita
    const hasPaymentStatus = appointment.payment_status === 'Pago' || appointment.payment_status === 'Aguardando Pagamento';

    // Validação: Não permite redimensionar se estiver Realizada, Cancelada, Faltou ou Desmarcada
    const canResize = !['Realizada', 'Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status);

    // Define se há sobreposição para mostrar o botão de expandir (se a largura for menor que 100%)
    const isOverlaying = layoutStyle && layoutStyle.width !== '100%';

    // Verifica se o agendamento permite drop (status cancelado/faltou/desmarcada)
    const isCancelledOrMissed = ['Cancelada', 'Faltou', 'Desmarcada'].includes(appointment.status);

    // Verifica se há serviços para mostrar
    const hasServices = appointment.servicos && appointment.servicos.length > 0;

    return (
        <Card 
            style={{ 
                top: `${top}px`, 
                ...styles.card, 
                width: isHovered ? '110%' : (layoutStyle ? layoutStyle.width : '100%'),
                left: isHovered ? '5%' : (layoutStyle ? layoutStyle.left : '1%'),
                height: isHovered ? 'auto' : `${height}px`, 
                minHeight: isHovered ? `${height}px` : '30px', 
                paddingBottom: isHovered ? '40px' : '0',
                background: `linear-gradient(90deg, ${colors.bg} 0%, ${colors.bg} 99%, #ffffff 100%)`, 
                color: colors.text,
                zIndex: isResizing ? 60 : (isHovered ? 50 : (10 + (layoutStyle?.zIndex || 0))),
                border: hasConflict ? '2px solid red' : undefined,
                transition: isResizing ? 'none' : 'width 0.2s ease, z-index 0.2s ease, left 0.2s ease'
            }}
            draggable={!isResizing && canResize} // Permite arrastar apenas se não estiver redimensionando e se o status permitir
            onDragStart={(e) => handleDragStart(e, appointment)}
            onDragEnd={handleDragEnd}
            onDragOver={(e) => {
                if (isCancelledOrMissed) {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                }
            }}
            onDrop={(e) => {
                if (isCancelledOrMissed && dayDate) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDrop(e, dayDate, appointment.hora_marcada.slice(0, 5));
                }
            }}
            onClick={(e) => { e.stopPropagation(); handleRowClick(appointment); }}
            onContextMenu={(e) => handleContextMenu(e, appointment)}
            onMouseEnter={() => setHoveredAppointmentId(appointment.id)}
            onMouseLeave={() => setHoveredAppointmentId(null)}
            key={appointment.id}
        >
            {/* Fita de Status de Pagamento (Canto Superior Esquerdo) */}
            {hasPaymentStatus && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    backgroundColor: 'white',
                    padding: '2px 15px 2px 5px', // Padding direito maior para o corte
                    clipPath: 'polygon(0 0, 100% 0, 80% 100%, 0% 100%)', // Corte de 45 graus
                    zIndex: 25,
                    fontSize: '10px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: (appointment.payment_status === 'Aguardando Pagamento' && canShowPayButton) ? 'pointer' : 'default'
                }}
                onClick={(e) => {
                    if (appointment.payment_status === 'Aguardando Pagamento' && canShowPayButton) {
                        e.stopPropagation();
                        handleOpenPaymentModal(appointment);
                    }
                }}
                >

                    {appointment.payment_status === 'Pago' && <FontAwesomeIcon icon={faDollarSign} style={{ color: '#198754', fontSize: '12px' }} title="Pago" />}
                    {appointment.payment_status === 'Aguardando Pagamento' && (
                        <>
                            <span style={{ color: '#dc3545' }}>R</span>
                            <FontAwesomeIcon icon={faDollarSign} style={{ color: '#dc3545', marginRight: '3px', fontSize: '10px' }} title="Receber" />                            
                        </>
                    )}
                </div>
            )}

            <Card.Body className="px-1 py-0 d-flex justify-content-between align-items-center" style={{ height: '100%', overflow: isHovered ? 'visible' : 'hidden' }}>
                <div className="flex-grow-1" style={{ overflow: 'hidden', lineHeight: '1.2', paddingTop: isHovered ? '15px' : '0', transition: 'padding-top 0.2s ease' }}>
                    <div className="d-flex align-items-center" style={{ width: '100%' }}>
                        {/* Adiciona paddingLeft se houver status de pagamento para não sobrepor o texto */}
                        <div className="fw-bold text-truncate" style={{ fontSize: '12px', flex: 1, minWidth: 0, paddingLeft: hasPaymentStatus ? '25px' : '0' }}>
                            {appointment.paciente?.nome}
                        </div>
                    </div>
                    
                    {isHovered && hasServices ? (
                        <div className="small" style={{ fontSize: '10px', whiteSpace: 'normal', lineHeight: '1.1', marginTop: '2px' }}>
                            <FontAwesomeIcon icon={faStethoscope} className="me-1" style={{ fontSize: '9px', opacity: 0.7 }}/>
                            {appointment.servicos.map(s => s.nome).join(', ')}
                        </div>
                    ) : (
                        <div className="text-truncate" style={{ fontSize: '10px' }}>
                            {appointment.hora_marcada.slice(0, 5)} - {appointment.status}
                            {height > 40 && <span className="ms-1 opacity-75">({duration} min)</span>}
                        </div>
                    )}
                </div>
                {/* Botões de Ação no Card (Dia/Semana) */}
                <div className="ms-1">{renderActionButtons(appointment)}</div>
            </Card.Body>

            {/* Botão/Indicador de Expandir */}
            {isOverlaying && !isHovered && !isResizing && (
                <div 
                    style={{ 
                        position: 'absolute', 
                        right: 0, 
                        top: 0, 
                        bottom: 0, 
                        width: '20px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        background: 'rgba(255,255,255,0.7)',
                        borderLeft: '1px solid rgba(0,0,0,0.1)',
                        zIndex: 20
                    }}
                    title="Expandir"
                >
                    <FontAwesomeIcon icon={faExpand} style={{ color: '#6c757d', fontSize: '10px' }} />
                </div>
            )}

            {/* Handle de Redimensionamento */}
            {canResize && (
            <div 
                style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '6px', cursor: 'ns-resize', zIndex: 10 }}
                onMouseDown={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setResizeState({
                        id: appointment.id,
                        startY: e.clientY,
                        startHeight: height,
                        currentHeight: height
                    });
                }}
            />
            )}
        </Card>
    )
  }

  return (
    <> {/* Envolve o conteúdo em um React.Fragment para permitir múltiplos elementos no nível raiz */}
      {/* CSS Injetado para corrigir a altura das Tabs e permitir scroll interno */}
      <style>{`
        .full-height-tabs-wrapper .tab-content { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
        .full-height-tabs-wrapper .tab-pane.active { flex: 1; display: flex; flex-direction: column; overflow: hidden; height: 100%; }
        
        @keyframes pulse-blue {
          0% {
            box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(13, 110, 253, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
          }
        }
        .fab-pulse {
          animation: pulse-blue 2s infinite;
        }
        .action-btn-hover:hover {
            background-color: #e9ecef !important;
            border-color: #dee2e6 !important;
        }

        /* Indenta as abas no mobile para dar espaço ao botão de menu à esquerda */
        .mobile-tabs-with-toggle.nav-tabs,
        .mobile-tabs-with-toggle .nav-tabs {
            padding-left: 50px !important;
        }

        /* Reduz o padding vertical das abas no mobile para economizar espaço */
        .mobile-small-padding-tabs.nav-tabs {
            --bs-nav-link-padding-y: 0.1rem;
        }
      `}</style>

      {/* Backdrop for mobile sidebar */}
      {!isDesktop && isSidebarOpen && (
          <div 
              style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1030 }}
              onClick={() => setIsSidebarOpen(false)}
          />
      )}

      {/* Gerenciador de toasts */}
      <LocalToastManager />
      
      <div style={styles.container}>
        {/* Left Sidebar */}
        <div style={styles.sidebar}>
          {/* Botão de fechar para mobile/tablet */}
          {!isDesktop && (
              <Button 
                  variant="close" 
                  onClick={() => setIsSidebarOpen(false)} 
                  aria-label="Fechar Menu"
                  className="position-absolute top-0 end-0 m-2 p-2" // Adicionado p-2 para aumentar a área de clique
                  style={{ zIndex: 1041 }}
              />
          )}
          {/* Sincroniza o agendamento selecionado na sidebar com a lista principal (fiveDayAppointments) */}
            {React.useEffect(() => {
                if (selectedSidebarAppointment) {
                    const updatedAppointment = fiveDayAppointments.find(app => app.id === selectedSidebarAppointment.id);
                    if (updatedAppointment) {
                        if (updatedAppointment !== selectedSidebarAppointment) {
                            setSelectedSidebarAppointment(updatedAppointment);
                        }
                    } else {
                        setSelectedSidebarAppointment(null);
                    }
                }
            }, [fiveDayAppointments, selectedSidebarAppointment])}

            {/* NOVO: Effect para calcular/buscar detalhes financeiros para a sidebar */}
            {React.useEffect(() => {
                let isMounted = true;
                const fetchDetails = async () => {
                    if (!selectedSidebarAppointment) {
                        if (isMounted) setSidebarDetails({ services: [], total: 0, loading: false, valorAdicional: 0, valorDesconto: 0, valorJaPago: 0 });
                        return;
                    }

                    if (isMounted) setSidebarDetails(prev => ({ ...prev, loading: true }));

                    try {
                        let services = [];
                        let total = 0;
                        let valorAdicional = 0;
                        let valorDesconto = 0;
                        let valorJaPago = 0;

                        // --- FIX: Garante dados completos para 'Aguardando Pagamento' ---
                        let appointmentData = selectedSidebarAppointment;
                        if (appointmentData.status === 'Aguardando Pagamento' && appointmentData.paciente_pacote_id && !appointmentData.paciente_pacote) {
                             try {
                                 const res = await axios.get(`/api/agendamentos/${appointmentData.id}`);
                                 if (res.data) {
                                     // Garante que o pagamento seja preservado se a API de detalhes não o retornar (dependendo da implementação do backend)
                                     appointmentData = { ...res.data, pagamento: res.data.pagamento || appointmentData.pagamento };
                                 }
                             } catch (e) {
                                 console.error("Erro ao buscar detalhes do pacote:", e);
                             }
                        }

                        // Calcula o valor já pago (soma dos pagamentos confirmados)
                        if (appointmentData.pagamento && appointmentData.pagamento.length > 0) {
                            valorJaPago = appointmentData.pagamento.reduce((acc, p) => {
                                if (p.status_pagamento === 'Confirmado') {
                                    return acc + parseFloat(p.valor_total_pago || 0);
                                }
                                return acc;
                            }, 0);
                        }

                        // 1. Se já foi PAGO
                        if (appointmentData.payment_status === 'Pago') {
                            let pagamentos = appointmentData.pagamento;
                            // Se não tiver pagamento carregado mas está pago, busca o agendamento completo
                            if (!pagamentos || pagamentos.length === 0) {
                                const res = await axios.get(`/api/agendamentos/${appointmentData.id}`);
                                pagamentos = res.data.agendamento?.pagamento || [];
                            }

                            if (pagamentos && pagamentos.length > 0) {
                                const allServicesMap = new Map();
                                pagamentos.forEach(p => {
                                    total += parseFloat(p.valor_total_pago || 0);
                                    valorAdicional += parseFloat(p.valor_adicional || 0);
                                    // valorDesconto += parseFloat(p.valor_desconto || 0); // Se disponível
                                    p.servicos.forEach(s => {
                                        const val = parseFloat(s.pivot.valor_servico_no_momento_pagamento || 0);
                                        const qtd = s.pivot.quantidade ? parseInt(s.pivot.quantidade, 10) : 1;

                                        if (allServicesMap.has(s.id)) {
                                            const existing = allServicesMap.get(s.id);
                                            existing.quantidade += qtd;
                                            existing.valor += val;
                                        } else {
                                            allServicesMap.set(s.id, {
                                                id: s.id,
                                                nome: s.nome,
                                                valor: val,
                                                isPacote: false,
                                                quantidade: qtd,
                                                comissionado: s.pivot.comissionado,
                                                valor_comissao: s.pivot.valor_comissao,
                                                tipo_comissao: s.pivot.tipo_comissao,
                                                funcionario_id: s.pivot.funcionario_id
                                            });
                                        }
                                    });
                                });
                                services = Array.from(allServicesMap.values());
                            }
                        } 
                        // 2. Se REALIZADA ou AGUARDANDO PAGAMENTO (e não pago)
                        else if (appointmentData.status === 'Realizada' || appointmentData.status === 'Aguardando Pagamento') {
                            const response = await axios.get(`/api/consultas/agendamento/${appointmentData.id}`);
                            const consulta = response.data.consulta;

                            if (consulta) {
                                const procedimentosInfo = JSON.parse(consulta.procedimentos || '[]');
                                const baseServices = consulta.servicos || appointmentData.servicos || [];
                                
                                services = baseServices.map(s => {
                                    const proc = procedimentosInfo.find(p => p.nome === s.nome);
                                    const qtd = proc ? (parseInt(proc.quantidade, 10) || 1) : 1;
                                    
                                    // Verifica se é um pacote (produto) ou se o paciente tem um pacote ativo para este serviço
                                    const isPacote = s.numero_sessoes > 1 || s.has_active_package;

                                    // Usa o valor real cobrado (do pivot) se disponível, senão calcula
                                    let totalItem = 0;
                                    if (s.has_active_package) {
                                        totalItem = 0;
                                    } else if (s.pivot && s.pivot.valor_servico !== undefined) {
                                        totalItem = parseFloat(s.pivot.valor_servico) * qtd;
                                    } else {
                                        let unitValue = parseFloat(s.valor || 0);
                                        if (proc && proc.valor_unitario !== undefined) unitValue = parseFloat(proc.valor_unitario);
                                        totalItem = unitValue * qtd;
                                    }
                                    
                                    total += totalItem;

                                    return { id: s.id, nome: s.nome, valor: totalItem, quantidade: qtd, isPacote };
                                });
                            }
                        }
                        // 3. Agendada / Outros (Fallback)
                        if (services.length === 0 && appointmentData.servicos) {
                             const fallbackMap = new Map();
                             appointmentData.servicos.forEach(s => {
                                const isPacote = s.numero_sessoes > 1 || s.has_active_package;
                                let val = parseFloat(s.valor || 0);
                                if (s.has_active_package) {
                                    val = 0;
                                } else if (s.pivot && s.pivot.valor_servico !== undefined) {
                                    val = parseFloat(s.pivot.valor_servico);
                                }
                                
                                total += val;
                                
                                if (fallbackMap.has(s.id)) {
                                    const existing = fallbackMap.get(s.id);
                                    existing.quantidade += 1;
                                    existing.valor += val;
                                } else {
                                    fallbackMap.set(s.id, { id: s.id, nome: s.nome, valor: val, quantidade: 1, isPacote });
                                }
                             });
                             services = Array.from(fallbackMap.values());
                        }

                        if (isMounted) setSidebarDetails({ services, total, valorAdicional, valorDesconto, valorJaPago, loading: false });
                    } catch (error) {
                        console.error("Erro ao calcular detalhes da sidebar:", error);
                        if (isMounted) setSidebarDetails(prev => ({ ...prev, loading: false }));
                    }
                };
                fetchDetails();
                return () => { isMounted = false; };
            }, [selectedSidebarAppointment])}

            {selectedSidebarAppointment ? (
                // --- VISUALIZAÇÃO DE DETALHES DO AGENDAMENTO ---
                <div className="d-flex flex-column h-100 fade-in">
                    <div className="mb-3">
                        <Button variant="outline-secondary" size="sm" onClick={() => setSelectedSidebarAppointment(null)} className="w-100">
                            <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Voltar para Calendário
                        </Button>
                    </div>
                    
                    <h5 className="mb-3 border-bottom pb-2">Detalhes</h5>

                    <div className="mb-3">
                        <label className="small text-muted fw-bold">PACIENTE</label>
                        <div className="fw-bold text-primary fs-5 mb-1">{selectedSidebarAppointment.paciente?.nome}</div>
                        {selectedSidebarAppointment.paciente?.cpf && (
                            <div className="small text-muted mb-1"><FontAwesomeIcon icon={faIdCard} className="me-1" /> {selectedSidebarAppointment.paciente.cpf}</div>
                        )}
                        {selectedSidebarAppointment.paciente?.celular && (
                            <div className="small text-muted mb-1"><FontAwesomeIcon icon={faPhone} className="me-1" /> {selectedSidebarAppointment.paciente.dddcelular}{selectedSidebarAppointment.paciente.celular}</div>
                        )}
                        {selectedSidebarAppointment.paciente?.email && (
                            <div className="small text-muted"><FontAwesomeIcon icon={faEnvelope} className="me-1" /> {selectedSidebarAppointment.paciente.email}</div>
                        )}
                        <Button variant="link" size="sm" className="p-0 text-decoration-none mt-2" onClick={handleOpenPackageHistory}>
                            <FontAwesomeIcon icon={faCalendarAlt} className="me-1" /> Ver Histórico de Pacotes
                        </Button>
                    </div>

                    <div className="mb-3">
                        <label className="small text-muted fw-bold">AGENDAMENTO</label>
                        <div className="d-flex align-items-center mb-2 mt-1">
                            <Badge bg={getStatusColors(selectedSidebarAppointment.status).bg} className="me-2" style={{ color: getStatusColors(selectedSidebarAppointment.status).text }}>
                                {selectedSidebarAppointment.status}
                            </Badge>
                            <span className="small text-muted"><FontAwesomeIcon icon={faClock} className="me-1" /> {selectedSidebarAppointment.hora_marcada.slice(0, 5)}</span>
                        </div>
                        <div className="small mb-1"><strong>Data:</strong> {new Date(selectedSidebarAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')}</div>
                        <div className="small mb-1"><strong>Tipo:</strong> {selectedSidebarAppointment.tipo}</div>
                        <div className="small mb-1">
                            <strong>Pagamento: </strong>
                            <Badge bg={selectedSidebarAppointment.payment_status === 'Pago' ? 'success' : 'warning'} text={selectedSidebarAppointment.payment_status === 'Pago' ? 'light' : 'dark'}>
                                {selectedSidebarAppointment.payment_status || 'Pendente'}
                            </Badge>
                        </div>
                        {selectedSidebarAppointment.medico && (
                             <div className="small mb-1"><strong>Profissional:</strong> {selectedSidebarAppointment.medico.nome}</div>
                        )}
                        {sidebarDetails.loading ? (
                            <div className="text-center my-2"><Spinner size="sm" /></div>
                        ) : sidebarDetails.services.length > 0 && (
                            <div className="mt-2">
                                <strong className="small">Serviços:</strong>
                                <ul className="list-unstyled mb-0 ps-3 small">
                                    {sidebarDetails.services.map((servico, idx) => {
                                        const funcionarioComissao = servico.funcionario_id && allFuncionarios
                                            ? allFuncionarios.find(f => f.id === servico.funcionario_id)
                                            : null;

                                        return (
                                            <li key={`${servico.id}-${idx}`} className="mb-2 border-bottom pb-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        {servico.nome}
                                                        {servico.quantidade > 1 && <span className="text-muted ms-1">x{servico.quantidade}</span>}
                                                        {servico.isPacote && <Badge bg="info" text="dark" className="ms-2 fw-normal" style={{fontSize: '0.7em'}} pill>Pacote</Badge>}
                                                    </div>
                                                    <div className="text-end">
                                                        {servico.valor === 0 ? <span className="text-muted text-decoration-line-through" style={{fontSize: '0.9em'}}>{formatCurrency(servico.valor)}</span> : <span>{formatCurrency(servico.valor)}</span>}
                                                    </div>
                                                </div>
                                                {servico.comissionado == 1 && (
                                                    <div className="text-muted small ms-2 mt-1">
                                                        <FontAwesomeIcon icon={faMoneyBillWave} className="me-1 text-success" />
                                                        <span className="text-success">
                                                            {servico.tipo_comissao === 'indicacao' ? 'Indicação gerada' : 'Comissão gerada'}
                                                            
                                                        </span>
                                                    </div>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                                {sidebarDetails.valorAdicional > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-1 ps-3 small text-muted">
                                        <span>Adicional:</span>
                                        <span>{formatCurrency(sidebarDetails.valorAdicional)}</span>
                                    </div>
                                )}
                                
                                {sidebarDetails.valorJaPago > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-1 ps-3 small text-success">
                                        <span>Valor Pago:</span>
                                        <span>- {formatCurrency(sidebarDetails.valorJaPago)}</span>
                                    </div>
                                )}

                                <div className="text-end fw-bold mt-2 border-top pt-1 small">
                                    Total: {formatCurrency(sidebarDetails.total)}
                                </div>
                                {sidebarDetails.valorJaPago > 0 && selectedSidebarAppointment.payment_status !== 'Pago' && (
                                     <div className="text-end fw-bold text-danger small">
                                        A Pagar: {formatCurrency(Math.max(0, sidebarDetails.total - sidebarDetails.valorJaPago))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {selectedSidebarAppointment.observacoes && (
                        <div className="mb-3">
                            <label className="small text-muted fw-bold">OBSERVAÇÕES</label>
                            <div className="small p-2 bg-light rounded border">{selectedSidebarAppointment.observacoes}</div>
                        </div>
                    )}
                    

                    <div className="mt-auto">
                        {selectedSidebarAppointment.status === 'Em andamento' && (
                            <Button variant="primary" className="w-100 mb-2" onClick={() => handleGoToProntuario(selectedSidebarAppointment)}>
                                <FontAwesomeIcon icon={faStethoscope} className="me-2" /> Ir para Prontuário
                            </Button>
                        )}
                    </div>
                    <div className="mt-3 border-top pt-3">
                        <h6 className="text-muted mb-2" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ações</h6>
                        {/* Check-in */}
                        {selectedSidebarAppointment.status === 'Agendada' && !selectedSidebarAppointment.hora_chegada && (
                            <Button variant="info" size="sm" className="w-100 mb-2 text-white" onClick={() => handleCheckIn(selectedSidebarAppointment.id)} disabled={loadingCheckIn[selectedSidebarAppointment.id]}>
                                {loadingCheckIn[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faCheck} className="me-2" /> Fazer Check-in</>}
                            </Button>
                        )}

                        
                        {/* Receber Pagamento */}
                        {(((selectedSidebarAppointment.status === 'Agendada' || selectedSidebarAppointment.status === 'Realizada') && selectedSidebarAppointment.payment_status === 'Aguardando Pagamento') ||
                          ((selectedSidebarAppointment.payment_status === 'Pago' || selectedSidebarAppointment.payment_status === 'Aguardando Pagamento') && selectedSidebarAppointment.status === 'Aguardando Pagamento')) && canShowPayButton && (
                            <Button variant="outline-danger" size="sm" className="w-100 mb-2" onClick={() => handleOpenPaymentModal(selectedSidebarAppointment)}>
                                <FontAwesomeIcon icon={faDollarSign} className="me-2" /> Receber
                            </Button>
                        )}

                        {/* Detalhes do Pagamento */}
                        {selectedSidebarAppointment.payment_status === 'Pago' && (currentUserRole === 'Representante Legal' || !!currentUser?.is_gerente) && (
                            <Button variant="info" size="sm" className="w-100 mb-2 text-white" onClick={() => handleOpenPaymentDetailsModal(selectedSidebarAppointment)}>
                                <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" /> Detalhes do Pagamento
                            </Button>
                        )}

                        {/* Cancelar Pagamento */}
                        {selectedSidebarAppointment.payment_status === 'Pago' && canShowCancelPayButton && 
                            ((selectedSidebarAppointment.servicos?.length || 0) > 1 || !selectedSidebarAppointment.paciente_pacote_id || selectedSidebarAppointment.pagamento?.length > 0) && (
                            <Button variant="outline-warning" size="sm" className="w-100 mb-2" onClick={() => handleOpenCancelPaymentModal(selectedSidebarAppointment)}>
                                <FontAwesomeIcon icon={faBan} className="me-2" /> Cancelar Pagamento
                            </Button>
                        )}

                        {/* Reagendar */}
                        {selectedSidebarAppointment.status === 'Agendada' && !selectedSidebarAppointment.hora_chegada && (
                            <Button variant="outline-secondary" size="sm" className="w-100 mb-2" onClick={() => handleOpenRescheduleModal(selectedSidebarAppointment)}>
                                <FontAwesomeIcon icon={faCalendarAlt} className="me-2" /> Reagendar
                            </Button>
                        )}

                        {/* Alterar Profissional */}
                        {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && selectedSidebarAppointment.status === 'Agendada' && (
                            <Button variant="outline-dark" size="sm" className="w-100 mb-2" onClick={() => {
                                setAppointmentToChangeProf(selectedSidebarAppointment);
                                setAvailableDoctors([]);
                                setChangeProfError(null);
                                setNewProfessionalId('');
                                setShowChangeProfModal(true);
                            }}>
                                <FontAwesomeIcon icon={faUserMd} className="me-2" /> Alterar Profissional
                            </Button>
                        )}

                        {/* Reutilizar Horário (Novo) */}
                        {['Cancelada', 'Faltou', 'Desmarcada'].includes(selectedSidebarAppointment.status) && (
                            <Button variant="success" size="sm" className="w-100 mb-2" onClick={() => {
                                const date = new Date(selectedSidebarAppointment.data_agendamento + 'T00:00:00'); // Usa a data do agendamento cancelado
                                const time = selectedSidebarAppointment.hora_marcada.slice(0, 5); // Usa a hora do agendamento cancelado
                                // Chama a função para abrir o modal, mas sem pré-selecionar médico/especialidade, e marcando como reutilização
                                handleTimeSlotClick(time, date, null, null, true);
                            }}>
                                <FontAwesomeIcon icon={faPlus} className="me-2" /> Reutilizar Horário
                            </Button>
                        )}

                        {/* Cancelar / Faltou */}
                        {['Agendada', 'Aguardando Pagamento', 'Confirmada'].includes(selectedSidebarAppointment.status) && (
                            <div className="d-flex gap-2">
                                <Button variant="outline-danger" size="sm" className="flex-grow-1" onClick={() => handleStatusChange(selectedSidebarAppointment.id, 'Cancelada')} disabled={loadingStatusChanges[selectedSidebarAppointment.id]}>
                                    {loadingStatusChanges[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faBan} className="me-2" /> Cancelar</>}
                                </Button>
                                <Button variant="outline-secondary" size="sm" className="flex-grow-1" onClick={() => handleStatusChange(selectedSidebarAppointment.id, 'Faltou')} disabled={loadingStatusChanges[selectedSidebarAppointment.id]}>
                                    {loadingStatusChanges[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faUserMd} className="me-2" /> Faltou</>}
                                </Button>
                            </div>
                        )}

                        {/* Retomar Atendimento */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id && (selectedSidebarAppointment.status === 'Realizada' || selectedSidebarAppointment.status === 'Aguardando Pagamento') && selectedSidebarAppointment.payment_status !== 'Pago' && (
                            <Button variant="outline-primary" size="sm" className="w-100 mb-2" onClick={() => handleRetomarAtendimento(selectedSidebarAppointment.id)} disabled={loadingStatusChanges[selectedSidebarAppointment.id]}>
                                {loadingStatusChanges[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faStethoscope} className="me-2" /> Rever Atendimento</>}
                            </Button>
                        )}

                        {/* Chamar Painel */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id && selectedSidebarAppointment.status === 'Agendada' && selectedSidebarAppointment.hora_chegada && (
                             <Button variant="outline-primary" size="sm" className="w-100 mb-2" onClick={() => handleChamarPaciente(selectedSidebarAppointment.id)} disabled={loadingChamar[selectedSidebarAppointment.id]}>
                                {loadingChamar[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faBullhorn} className="me-2" /> Chamar Painel</>}
                            </Button>
                        )}

                        {/* Iniciar Consulta */}
                        {isCurrentUserCorpoClinico && selectedSidebarAppointment.medico_id === currentUser?.id && selectedSidebarAppointment.status === 'Agendada' && (
                            <Button variant={selectedSidebarAppointment.hora_chegada ? "success" : "secondary"} size="sm" className="w-100 mb-2" onClick={() => handleIniciarConsulta(selectedSidebarAppointment.id)} disabled={loadingIniciarConsulta[selectedSidebarAppointment.id] || !selectedSidebarAppointment.hora_chegada}>
                                {loadingIniciarConsulta[selectedSidebarAppointment.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={faStethoscope} className="me-2" /> Iniciar Consulta</>}
                            </Button>
                        )}
                    </div>
                </div>
            ) : (
                // --- VISUALIZAÇÃO PADRÃO (CALENDÁRIO E FILTROS) ---
                <>
                <h5 className="mb-3">Calendário</h5>
                <div className="d-flex justify-content-center mb-3">
                <Calendar
                    onChange={(date) => {
                        handleDateChange(date);
                        setShowCalendarModal(false); 
                    }}
                    value={selectedDate}
                    activeStartDate={activeStartDate} 
                    tileClassName={({ date, view }) => getTileClass({ date, view, getFeriadoNome, availabilityData, nextAvailableDate, totalSlotsDisponiveis })}
                    tileDisabled={isTileDisabled} 
                    onActiveStartDateChange={handleActiveStartDateChange}
                />
                </div>
            
                {!isCurrentUserCorpoClinico && (
                <>
                  <hr />
                  <div className="mb-3">
                    <label className="form-label small text-muted fw-bold mb-1">Especialidade</label>
                    <Select
                      options={especialidades.map(e => ({ value: e.id, label: e.nome }))}
                      value={selectedEspecialidade ? { value: selectedEspecialidade, label: especialidades.find(e => e.id === parseInt(selectedEspecialidade))?.nome } : null}
                      onChange={(opt) => handleEspecialidadeChange({ target: { value: opt ? opt.value : '' } })}
                      placeholder="Todas"
                      isClearable
                      classNamePrefix="react-select"
                      styles={{ control: (base) => ({ ...base, fontSize: '0.85rem', minHeight: '36px' }) }}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label small text-muted fw-bold mb-1">Médico</label>
                    <Select
                      options={localMedicos.map(m => ({ value: m.id, label: m.nome }))}
                      value={selectedMedico ? { value: selectedMedico, label: localMedicos.find(m => m.id === parseInt(selectedMedico))?.nome } : null}
                      onChange={(opt) => handleMedicoChange({ target: { value: opt ? opt.value : '' } })}
                      placeholder="Todos"
                      isClearable
                      classNamePrefix="react-select"
                      styles={{ control: (base) => ({ ...base, fontSize: '0.85rem', minHeight: '36px' }) }}
                    />
                  </div>
                </>
                )}

                <div className="mt-4">
              <h6 className="text-muted mb-3" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Legenda</h6>
              <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-center">
                  <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#28a745', marginRight: '10px' }}></span>
                  <span style={{ fontSize: '0.85rem', color: '#495057' }}>Próxima Vaga</span>
                </div>
                <div className="d-flex align-items-center">
                  <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#dc3545', marginRight: '10px' }}></span>
                  <span style={{ fontSize: '0.85rem', color: '#495057' }}>Sem Vagas</span>
                </div>
                <div className="d-flex align-items-center">
                  <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#ffc107', marginRight: '10px' }}></span>
                  <span style={{ fontSize: '0.85rem', color: '#495057' }}>Feriado</span>
                </div>
                <div className="d-flex align-items-center">
                  <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#6c757d', marginRight: '10px' }}></span>
                  <span style={{ fontSize: '0.85rem', color: '#495057' }}>Bloqueado</span>
                </div>
              </div>
                </div>
                </>
            )}
        </div>

       {/* Main Content */}
        <div style={styles.main}>
            {/* Wrapper para garantir que as Tabs ocupem a altura correta e permitam scroll */}
            <div className="d-flex flex-column h-100 full-height-tabs-wrapper" style={{ position: 'relative' }}>
                
                {/* Botão de Menu (Mobile/Tablet) - Posicionado à Esquerda e em Evidência */}
                {!isDesktop && (
                    <div className="position-absolute top-0 start-0 mt-2 ms-2" style={{ zIndex: 20 }}>
                        <Button variant="primary" size="sm" className="shadow-sm" onClick={() => setIsSidebarOpen(!isSidebarOpen)} title="Abrir/Fechar Menu Lateral">
                            <FontAwesomeIcon icon={faBars} />
                        </Button>
                    </div>
                )}

                {/* Filtros Desktop (Posição Absoluta) */}
                {activeTab === 'agenda' && isDesktop && renderFilters(false)}

                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="agenda-view-tabs" className={`mb-0 border-bottom-0 pt-2 bg-white ${isMobile ? 'mobile-small-padding-tabs' : ''} ${!isDesktop ? 'mobile-tabs-with-toggle' : 'px-2'}`}>
                    <Tab eventKey="agenda" title="Agenda">
                        <div className="d-flex flex-column h-100">
                            {/* Filtros Mobile/Tablet (Abaixo das Tabs) */}
                            {!isDesktop && renderFilters(true)}
                            
                            {/* Header */}
                            <div style={styles.header}>
                                {viewMode !== 'month' && <div style={styles.timeColumn}></div>}
                                {viewMode === 'month' ? (
                                    getVisibleDays().slice(0, 7).map((day, index) => (
                                        <div key={index} style={styles.headerCell} className="text-capitalize">
                                        </div>
                                    ))
                                ) : (
                                    getVisibleDays().map((day, index) => (
                                        <div key={index} style={styles.headerCell}>
                                            {isMobile ? (
                                                // Mobile: S 19
                                                <div style={{ fontSize: '0.8rem', lineHeight: '1.2' }}>
                                                    <div className="text-uppercase">{day.toLocaleDateString('pt-BR', { weekday: 'narrow' })}</div>
                                                    <div>{day.getDate()}</div>
                                                </div>
                                            ) : isTablet ? (
                                                // Tablet: Seg 19
                                                <div style={{ fontSize: '0.9rem' }}>
                                                    {day.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '').charAt(0).toUpperCase() + day.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '').slice(1)} {day.getDate()}
                                                </div>
                                            ) : (
                                                // Desktop: Segunda 19/01/2025
                                                <>
                                                    <div className="text-capitalize">{day.toLocaleDateString('pt-BR', { weekday: 'long' }).split('-')[0]}</div>
                                                    <div style={{ fontSize: '0.85rem', fontWeight: 'normal' }}>{day.toLocaleDateString('pt-BR')}</div>
                                                </>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                            
                            {/* Body - Adicionado ref={scrollRef} para controle de rolagem */}
                            <div style={styles.body} ref={scrollRef}>
                                {/* ... (restante do código do body) ... */}
                                {viewMode === 'month' ? (
                                    <div className="d-flex flex-wrap w-100">
                                        {getVisibleDays().map((day, index) => {
                                            // ... (lógica do mês) ...
                                            const dayStr = day.toISOString().split('T')[0];
                                            const dayAppointments = fiveDayAppointments.filter(app => {
                                                if (app.data_agendamento !== dayStr) return false;
                                                if (showOnlyPendingPayment) {
                                                    return app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento';
                                                }
                                                return true;
                                            });
                                            const isCurrentMonth = day.getMonth() === selectedDate.getMonth();
                                            const isToday = day.toDateString() === new Date().toDateString();
                                            

                                            return (
                                                <div 
                                                    key={index} 
                                                    style={{ 
                                                        ...styles.monthCell, 
                                                        width: '14.28%', 
                                                        backgroundColor: isCurrentMonth ? '#fff' : '#f9f9f9' 
                                                    }}
                                                    onClick={() => {
                                                        setSelectedDate(day);
                                                        setViewMode('day');
                                                    }}
                                                >
                                                    <div className={`text-end mb-1 ${isToday ? 'fw-bold text-primary' : ''}`} style={{ fontSize: '12px' }}>
                                                        {day.getDate()}
                                                    </div>
                                                    <div style={{ fontSize: '10px' }}>
                                                        {dayAppointments.map(app => {
                                                            const colors = getStatusColors(app.status);
                                                            
                                                            const popover = (
                                                                <Popover id={`popover-appointment-${app.id}`}>
                                                                    <Popover.Header as="h3">{app.paciente?.nome}</Popover.Header>
                                                                    <Popover.Body>
                                                                        <p className="mb-2"><strong>Horário:</strong> {app.hora_marcada.slice(0,5)}</p>
                                                                        <p className="mb-2"><strong>Status:</strong> {app.status}</p>
                                                                        {renderActionButtons(app)}
                                                                    </Popover.Body>
                                                                </Popover>
                                                            );

                                                            return (
                                                            <OverlayTrigger trigger="click" rootClose placement="auto" overlay={popover} key={app.id}>
                                                            <div 
                                                                className={`mb-1 badge w-100 text-start d-flex justify-content-between align-items-center`}
                                                                style={{ backgroundColor: colors.bg, color: colors.text, cursor: 'pointer' }}
                                                                onClick={(e) => { e.stopPropagation(); handleRowClick(app); }}
                                                            >
                                                                <span className="text-truncate" style={{ flex: 1 }}>{app.hora_marcada.slice(0,5)} {app.paciente?.nome}</span>
                                                                <span className="flex-shrink-0 ms-1">
                                                                    {app.payment_status === 'Pago' && <FontAwesomeIcon icon={faCheckCircle} style={{fontSize: '12px', color: '#198754'}} title="Pago" />}
                                                                    {app.payment_status === 'Aguardando Pagamento' && <FontAwesomeIcon icon={faDollarSign} style={{fontSize: '9px', color: colors.text === '#fff' ? '#fff' : '#dc3545'}} title="Aguardando Pagamento" />}
                                                                </span>
                                                            </div>
                                                            </OverlayTrigger>
                                                        )})}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <>
                                {/* Time Column */}
                                <div style={styles.timeColumn}>
                                    {timeSlots.map((time, index) => (
                                        <div key={index} style={styles.timeSlot}>{time}</div>
                                    ))}
                                </div>

                                {/* Day Columns */}
                                {getVisibleDays().map((day, dayIndex) => {
                                    const isToday = day.toDateString() === new Date().toDateString();
                                    const dayStr = day.toISOString().split('T')[0];
                                    const dayAppointments = fiveDayAppointments.filter(app => {
                                        if (app.data_agendamento !== dayStr) return false;
                                        if (showOnlyPendingPayment) {
                                            return app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento';
                                        }
                                        return true;
                                    });
                                    
                                    // Ordena por horário para garantir empilhamento correto
                                    dayAppointments.sort((a, b) => a.hora_marcada.localeCompare(b.hora_marcada));
                                    
                                    // Calcula conflitos para o dia atual
                                    const conflicts = getConflicts(dayAppointments);

                                    // Calcula layout dos eventos (largura e posição)
                                    const layout = calculateEventLayout(dayAppointments);

                                    return (
                                        <div key={dayIndex} style={styles.dayColumn}>
                                            {/* Red Line (only for today) */}
                                            {isToday && redLineTop >= 0 && (
                                                <div style={{ ...styles.redLine, top: `${redLineTop}px` }}>
                                                    <div style={styles.redDot}></div>
                                                </div>
                                            )}

                                            {/* Slots Background */}
                                            {timeSlots.map((time, timeIndex) => (
                                                <div 
                                                    key={timeIndex} 
                                                    style={styles.daySlot} 
                                                    onClick={() => handleTimeSlotClick(time, day)}
                                                    onDragOver={handleDragOver}
                                                    onDrop={(e) => handleDrop(e, day, time)}
                                                ></div>
                                            ))}

                                            {/* Appointments */}
                                            {dayAppointments.map(app => renderEvent(app, conflicts.has(app.id), layout[app.id], day))}
                                        </div>
                                    );
                                })}
                                    </>
                                )}
                            </div>
                            {/* Floating Action Button for New Appointment */}
                            <Button 
                                variant="primary" 
                                style={styles.fab} 
                                className={!loadingFiveDays && fiveDayAppointments.length === 0 ? 'fab-pulse' : ''}
                                onClick={handleFabClick} 
                                title="Novo Agendamento"
                            >
                                <FontAwesomeIcon icon={faPlus} size="lg" />
                            </Button>
                        </div>
                    </Tab>
                

                
                {isCurrentUserCorpoClinico && (
                  <Tab eventKey="ordemChegada" title="Ordem de Chegada">
                    <div className="p-3 bg-white h-100 overflow-auto">
                    {isLoadingOrdemDeChegada ? (
                      <div className="text-center my-3"><Spinner animation="border" /></div>
                    ) : ordemDeChegada.length === 0 ? (
                      <Alert variant="info" className="text-center my-3">Nenhum paciente aguardando atendimento.</Alert>
                    ) : (
                      <Table striped bordered hover responsive size="sm">
                        <thead>
                          <tr>
                            <th style={{ width: '5%' }}>Ordem</th>
                            <th style={{ width: '10%' }}>Chegada</th>
                            <th style={{ width: '10%' }}>Agendado p/</th>
                            <th>Paciente</th>
                            <th>Status Pag.</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ordemDeChegada.filter(app => {
                              if (showOnlyPendingPayment) {
                                  return app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento';
                              }
                              return true;
                          }).map((app, index) => (
                            <tr key={app.id}>
                              <td className="text-center">{index + 1}º</td>
                              <td>{new Date(app.hora_chegada).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</td>
                              <td>{app.hora_marcada.slice(0, 5)}</td>
                              <td>{app.paciente?.nome || '-'}</td>
                              <td><Badge bg={app.payment_status === 'Pago' ? 'success' : 'warning'}>{app.payment_status || 'Pendente'}</Badge></td>
                              <td>
                                <Button variant="success" size="sm" onClick={() => handleIniciarConsulta(app.id)} disabled={loadingIniciarConsulta[app.id] || app.payment_status !== 'Pago'}>
                                  {loadingIniciarConsulta[app.id] ? 'Iniciando...' : 'Iniciar Consulta'}
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                    </div>
                  </Tab>
                )}

                {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && (
                  <Tab eventKey="todos" title="Todos os Médicos">
                     <div className="p-3 bg-white h-100 overflow-auto">
                    {isLoadingAllAppointments ? (
                      <div className="text-center my-3"><Spinner animation="border" role="status" /></div>
                    ) : allAppointmentsError ? (
                      <div className="text-center my-3"><Alert variant="warning">{allAppointmentsError}</Alert></div>
                    ) : Object.keys(appointmentsByMedico).length === 0 ? (
                      <p className="text-center my-3">Não há agendamentos para o dia selecionado.</p>
                    ) : (
                      <Accordion defaultActiveKey={Object.keys(appointmentsByMedico)[0]} alwaysOpen>
                        {Object.keys(appointmentsByMedico).map((medicoId) => (
                          <Accordion.Item eventKey={medicoId} key={medicoId}>
                            <Accordion.Header>
                              Dr(a). {todosMedicos.find(m => m.id === parseInt(medicoId, 10))?.nome || 'Não Identificado'}
                            </Accordion.Header>
                            <Accordion.Body>
                              <Table striped bordered hover responsive size="sm">
                                <thead>
                                  <tr>
                                    <th>Hora</th>
                                    <th>Paciente</th>
                                    <th>Tipo</th>
                                    <th>Status</th>
                                    <th>Pagamento</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {appointmentsByMedico[medicoId].filter(app => {
                                      if (showOnlyPendingPayment) {
                                          return app.payment_status === 'Aguardando Pagamento' || app.status === 'Aguardando Pagamento';
                                      }
                                      return true;
                                  }).map(app => (
                                    <tr key={app.id}>
                                      <td>{app.hora_marcada.slice(0, 5)}</td>
                                      <td>{app.paciente?.nome || '-'}</td>
                                      <td>{app.tipo}</td>
                                      <td>{app.status}</td>
                                      <td><Badge bg={app.payment_status === 'Pago' ? 'success' : 'danger'}>{app.payment_status || 'Pendente'}</Badge></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    )}
                    </div>
                  </Tab>
                )}
            </Tabs>
            </div>
        </div>
      </div>

      {/* Modal de Agendamento */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Novo Agendamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Alerta de Pacotes Ativos */}
            {/* Seletor de Médico/Especialidade (agora dentro do modal) */}
            {(currentUserRole !== 'Médico' || isReusingSlot) && (
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="modalEspecialidade">
                    <Form.Label>Especialidade: *</Form.Label>
                    <Form.Control as="select" name="especialidade_id" value={newAppointment.especialidade_id} onChange={handleModalFormChange} required>
                      <option value="">Selecione...</option>
                      {especialidades.map(esp => <option key={esp.id} value={esp.id}>{esp.nome}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="modalMedico">
                    <Form.Label>Médico: *</Form.Label>
                    <Form.Control as="select" name="medico_id" value={newAppointment.medico_id} onChange={handleModalFormChange} required disabled={!newAppointment.especialidade_id}>
                      <option value="">Selecione a especialidade</option>
                      {todosMedicos
                        .filter(m => m.especialidade_id === parseInt(newAppointment.especialidade_id))
                        .map(med => <option key={med.id} value={med.id}>{med.nome}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Informações do Profissional (Visualização para o médico no fluxo normal) */}
            {currentUserRole === 'Médico' && !isReusingSlot && (
              <Alert variant="light" className="mb-3 py-2 border">
                  <div className="d-flex flex-column">
                      <small className="text-muted fw-bold">PROFISSIONAL</small>
                      <span>
                          {todosMedicos.find(m => m.id === parseInt(newAppointment.medico_id))?.nome || 'Selecione um médico'} 
                          <span className="mx-2">|</span> 
                          {especialidades.find(e => e.id === parseInt(newAppointment.especialidade_id))?.nome || 'Especialidade'}
                      </span>
                  </div>
              </Alert>
            )}
            {/* Seleção de Paciente */}
            <Row className="align-items-center mb-3">
              <Col xs={12} sm={10} className="mb-2 mb-sm-0">
                <Form.Group controlId="paciente" ref={pacienteDropdownRef} style={{ position: 'relative' }}>
                  <Form.Label>Paciente: *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite para buscar um paciente..."
                    value={pacienteSearch}
                    onChange={(e) => {
                      setPacienteSearch(e.target.value);
                      setShowPacientesDropdown(true);
                      // Limpa o ID do paciente se o usuário começar a digitar novamente
                      if (newAppointment.paciente_id) {
                        setNewAppointment({ ...newAppointment, paciente_id: '' });                        
                        setSelectedPackageId(null);
                        setSelectedServicos([]);
                      }
                    }}
                    onFocus={() => setShowPacientesDropdown(true)}
                    required={!newAppointment.paciente_id} // Obrigatório apenas se nenhum paciente estiver selecionado
                    autoComplete="off"
                  />
                  {showPacientesDropdown && (
                    <ListGroup className="paciente-dropdown">
                      {filteredPacientes.length > 0 ? (
                        filteredPacientes.slice(0, 6).map(patient => ( // Limita a 6 resultados para performance
                          <ListGroup.Item
                            key={patient.id}
                            action
                            onClick={() => {
                              setNewAppointment({ ...newAppointment, paciente_id: patient.id });
                              setPacienteSearch(patient.nome);
                              setShowPacientesDropdown(false);
                            }}
                          >
                            {patient.nome}
                          </ListGroup.Item>
                        ))
                      ) : (<ListGroup.Item disabled>Nenhum paciente encontrado.</ListGroup.Item>)}
                    </ListGroup>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={2} className="text-sm-end mt-2 mt-sm-0 d-flex align-items-end justify-content-center justify-content-sm-end">
                <img
                  src={addPatientIcon}
                  alt="Cadastrar novo paciente"
                  title='Cadastrar novo paciente'
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }} // Aumentei um pouco o ícone
                  onClick={handleOpenCreatePatientModal}
                />
              </Col>
            </Row>

            {/* Tipo */}
            <Form.Group controlId="tipo" className="mb-3">
              <Form.Label>Tipo:</Form.Label>
              <Form.Control
                as="select"
                name="tipo"
                value={newAppointment.tipo || 'Consulta'}
                onChange={(e) => setNewAppointment({ ...newAppointment, tipo: e.target.value })}
                required
              >
                <option value="Consulta">Consulta</option>
                <option value="Retorno">Retorno</option>
                <option value="Procedimento">Procedimento</option>
              </Form.Control>
            </Form.Group>

            {/* Data e Hora (somente leitura) */}
            <Row className="mb-3">
              <Col xs={12} sm={6} className="mb-2 mb-sm-0">
                <Form.Group controlId="data">
                  <Form.Label>Data:</Form.Label>
                  <Form.Control
                    type="text"
                    value={newAppointment.data_agendamento ? new Date(newAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR') : ''} // Formata a data
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6}>
                <Form.Group controlId="hora">
                  <Form.Label>Hora:</Form.Label>
                  <Form.Control
                    type="text"
                    value={newAppointment.hora_marcada || ''}
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="servicos" className="mb-3">
              <Form.Label>Serviços:</Form.Label>
              <Select
                isMulti
                // Filtra serviços ativos OU inativos que o paciente tenha pacote
                options={(servicos || []).filter(servico => {
                  if (servico.ativo) return true;
                  return pacientePacotesAtivos.some(p => p.servico_id === servico.id);
                }).map(servico => {
                  const pacoteAtivo = pacientePacotesAtivos.find(p => p.servico_id === servico.id);
                  const label = `${servico.nome}${pacoteAtivo ? ` (Pacote - ${pacoteAtivo.sessoes_restantes} restantes)` : ''}`;
                  return {
                    value: servico.id,
                    label: label,
                    pacoteId: pacoteAtivo ? pacoteAtivo.id : null,
                    isDisabled: !pacoteAtivo && selectedPackageId !== null
                  };
                })}
                value={servicos.filter(s => selectedServicos.includes(s.id)).map(s => ({ value: s.id, label: s.nome }))}
                onChange={(selectedOptions) => {
                  // Para manter a lógica de pacotes simples, pegamos o último item selecionado
                  const lastSelected = selectedOptions[selectedOptions.length - 1];
                  handleServicoChange(lastSelected?.value, lastSelected?.pacoteId);
                }}
                placeholder="Digite para buscar e selecionar serviços..."
                noOptionsMessage={() => 'Nenhum serviço encontrado'}
              />
            </Form.Group>

            {/* O campo de Interesses só aparece APÓS selecionar um paciente E SE houver interesses disponíveis para ele */}
            {newAppointment.paciente_id && filteredInteresseOptions.length > 0 && (
              <Form.Group controlId="interesses" className="mb-3">
                <Form.Label>Adicionar Interesses (Opcional):</Form.Label>
                <Select
                  isMulti
                  options={filteredInteresseOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Selecione para adicionar..."
                  noOptionsMessage={() => 'Nenhuma nova tag disponível'}
                  value={newAppointment.interesses}
                  onChange={(selectedOptions) => setNewAppointment({ ...newAppointment, interesses: selectedOptions || [] })}
                />
                <Form.Text className="text-muted">
                  Mostrando apenas interesses que o paciente ainda não possui.
                </Form.Text>
              </Form.Group>
            )}

            {/* Botões de ação - Ajustados para melhor responsividade */}
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={handleCloseModal} className="me-2">
                Cancelar
              </Button>
              <Button variant="primary" onClick={handleCreateAppointment}>
                {isLoadingCreate ? (
                  <Spinner animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                ) : null}
                {isLoadingCreate ? 'Agendando...' : 'Agendar'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal de Cadastro de Paciente */}
      <Modal show={showCreatePatientModal} onHide={handleCloseCreatePatientModal}>
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Novo Paciente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="nome">
              <Form.Label>Nome: *</Form.Label>
              <Form.Control
                type="text"
                name="nome"
                value={newPatient.nome}
                onChange={handleNewPatientInputChange}
                required
              />
            </Form.Group>
            {/* Campo CPF */}
            <Form.Group controlId="cpf">
              <Form.Label>CPF: *</Form.Label>
              <InputMask
                mask="999.999.999-99"
                value={newPatient.cpf}
                onChange={handleNewPatientInputChange}
                name="cpf"
              >
                {(inputProps) => <Form.Control {...inputProps} type="text" required />}
              </InputMask>
            </Form.Group>

            {/* Campo Data de Nascimento */}
            <Form.Group controlId="data_nascimento">
              <Form.Label>Data de Nascimento: *</Form.Label>
              <Form.Control
                type="date" // Use type="date" para um campo de data
                name="data_nascimento"
                value={newPatient.data_nascimento}
                onChange={handleNewPatientInputChange}
                required
              />
            </Form.Group>

            {/* Campo Sexo */}
            <Form.Group controlId="sexo">
              <Form.Label>Sexo: *</Form.Label>
              <Form.Control as="select"
                name="sexo"
                value={newPatient.sexo}
                onChange={handleNewPatientInputChange}
                required>
                <option value="N">Selecione o sexo</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
                <option value="O">Outro</option>
              </Form.Control>
            </Form.Group>

            {/* Campo Email */}
            <Form.Group controlId="email">
              <Form.Label>Email: *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newPatient.email}
                onChange={handleNewPatientInputChange}
                required
              />
            </Form.Group>

            {/* Campo Telefone Unificado com Máscara */}
            <Form.Group controlId="telefone">
              <Form.Label>Telefone: *</Form.Label>
              <InputMask
                mask="(99) 99999-9999"
                value={`${newPatient.dddcelular}${newPatient.celular}`}
                onChange={handleNewPatientPhoneChange}
                name="telefone"
              >
                {(inputProps) => <Form.Control {...inputProps} type="tel" required />}
              </InputMask>
            </Form.Group>

            {/* Campo Endereço */}
            <Form.Group controlId="endereco">
              <Form.Label>Endereço:</Form.Label>
              <Form.Control
                type="text"
                name="endereco"
                value={newPatient.endereco}
                onChange={handleNewPatientInputChange}
                required
              />
            </Form.Group>

            {/* Campo Opção de Convênio */}
            <Form.Group controlId="op_convenio">
              <Form.Label>Opção de Convênio:</Form.Label>
              <Form.Control
                type="text"
                name="op_convenio"
                value={newPatient.op_convenio}
                onChange={handleNewPatientInputChange}
                required
              />
            </Form.Group>


            <Button variant="secondary" onClick={handleCloseCreatePatientModal}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleCreatePatient} disabled={isCreatingPatient}>
              {isCreatingPatient ? <Spinner as="span" animation="border" size="sm" /> : null}
              {isCreatingPatient ? ' Cadastrando...' : 'Cadastrar'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

     
      {/* Outros Modais */}
      <PaymentModal
        show={showPaymentModal}
        handleClose={handleClosePaymentModal}
        appointment={selectedAppointmentForPayment}
        // --- CORREÇÃO: Passa para o modal de pagamento apenas os serviços ativos ---
        allServices={(servicos || []).filter(s => s.ativo)}
        allFuncionarios={allFuncionarios} // Passa a lista completa de funcionários
        onPaymentConfirm={handlePaymentConfirmation}
        />

      {/* 2. Renderizar o novo componente */}
      <CommunicationModal
        show={showCommunicationModal}
        onHide={() => setShowCommunicationModal(false)}
        appointments={calendarAppointments}
        pacientesList={pacientesList}
        todosMedicos={todosMedicos}
        especialidades={especialidades}
        currentEntidade={currentEntidade}
        currentUser={currentUser}
        onSendComplete={onAppointmentStatusChange} // Notifica o pai para re-buscar os dados
      />

      {/* Modal de Reagendamento */}
      <Modal show={showRescheduleModal} onHide={handleCloseRescheduleModal} centered>
        <Modal.Header closeButton>

          <Modal.Title>Reagendar Consulta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {appointmentToReschedule && (
            <>
              <p><strong>Paciente:</strong> {appointmentToReschedule.paciente?.nome}</p>
              <p><strong>Data Atual:</strong> {new Date(appointmentToReschedule.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')} às {appointmentToReschedule.hora_marcada.slice(0, 5)}</p>
              <hr />
              <Form.Group controlId="newScheduleDate">
                <Form.Label><strong>Selecione a nova data:</strong></Form.Label>
                <DatePicker
                  selected={newScheduleDate}
                  onChange={(date) => setNewScheduleDate(date)}
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  className="form-control"
                  minDate={new Date()} // Impede a seleção de datas passadas
                  filterDate={filterRescheduleDates} // Aplica as regras de feriado, sem vagas, etc.
                />
              </Form.Group>

              <Form.Group controlId="newScheduleTime" className="mt-3">
                <Form.Label><strong>Selecione o novo horário:</strong></Form.Label>
                {isLoadingSlots ? (
                  <div className="text-center">
                    <Spinner animation="border" size="sm" />
                    <p>Buscando horários...</p>
                  </div>
                ) : newAvailableSlots.length > 0 ? (
                  <div className="available-slots-grid">
                    {newAvailableSlots.map(slot => (
                      <Button
                        key={slot}
                        variant={selectedNewTime === slot ? 'primary' : 'outline-primary'}
                        onClick={() => setSelectedNewTime(slot)}
                        className="m-1"
                      >
                        {slot}
                      </Button>
                    ))}
                  </div>
                ) : (
                  <Alert variant="warning" className="mt-2">
                    Não há horários disponíveis para esta data.
                  </Alert>
                )}
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRescheduleModal} disabled={isLoadingReschedule}>
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={handleConfirmReschedule}
            disabled={!selectedNewTime || isLoadingReschedule}
          >
            {isLoadingReschedule ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : null}
            {isLoadingReschedule ? ' Reagendando...' : 'Confirmar Reagendamento'}

          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal do Calendário */}
      <Modal show={showCalendarModal} onHide={() => setShowCalendarModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecione uma Data</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <div> {/* Div interna para o calendário e seus elementos */}
            <Calendar
              onChange={(date) => {
                handleDateChange(date);
                setShowCalendarModal(false); // Fecha o modal ao selecionar a data
              }}
              value={selectedDate}
              activeStartDate={activeStartDate} // Garante que o modal abra no mês correto
              tileClassName={({ date, view }) => getTileClass({ date, view, getFeriadoNome, availabilityData, nextAvailableDate, totalSlotsDisponiveis })}
              tileDisabled={isTileDisabled} // Desabilita a seleção de domingos e feriados
              onActiveStartDateChange={handleActiveStartDateChange}
            />

            <div className="calendar-legends mt-3">
              <div className="legend-item">
                <div className="vaga-proxima legends text-center">
                  <span title='Próxima vaga disponível'>Próx. Vaga</span>
                </div>
              </div>
              <div className="legend-item">
                <div className="sem-vagas legends text-center">
                  <span title='Sem vagas'>Sem Vagas</span>
                </div>
              </div>
              <div className="legend-item">
                <div className="feriado legends text-center">
                  <span title="Feriado">Feriado</span>
                </div>
              </div>
              <div className="legend-item">
                <div className="bloqueado legends text-center">
                  <span title="Bloqueado">Bloqueado</span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCalendarModal(false)}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* --- Modal para Alterar Profissional (MODIFICADO) --- */}
      <Modal show={showChangeProfModal} onHide={() => setShowChangeProfModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Alterar Profissional</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {changeProfError && <Alert variant="danger">{changeProfError}</Alert>}
          <p>Selecione o novo profissional para o atendimento do paciente <strong>{appointmentToChangeProf?.paciente?.nome}</strong>.</p>
          <Form.Group controlId="changeProfessionalSelect">
            <Form.Label>Novo Profissional:</Form.Label>
            <Form.Select
              value={newProfessionalId}
              onChange={(e) => setNewProfessionalId(e.target.value)}
              isInvalid={!!changeProfError} // Marca o campo como inválido se houver erro
              required
            >
              <option value="">Selecione um profissional...</option>
              {/* Se houver uma lista de médicos disponíveis, usa ela. Senão, usa a lista completa. */}
              {(availableDoctors.length > 0 ? availableDoctors : todosMedicos).map(medico => (
                <option key={medico.id} value={medico.id}>{medico.nome}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowChangeProfModal(false)} disabled={isUpdatingProfessional}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            disabled={!newProfessionalId || isUpdatingProfessional}
            onClick={async () => {
              if (!appointmentToChangeProf) return;
              setIsUpdatingProfessional(true);
              setChangeProfError(null); // Limpa o erro antes de tentar novamente
              setAvailableDoctors([]); // Limpa a lista de disponíveis
              try {
                const response = await axios.put(`/api/agendamentos/${appointmentToChangeProf.id}/change-professional`, { medico_id: newProfessionalId });
                onAppointmentStatusChange(response.data.agendamento); // Notifica o pai para atualizar a lista
                showAlertModal('Sucesso', 'Profissional alterado com sucesso!', 'success');
                setShowChangeProfModal(false);
              } catch (error) {
                // --- LÓGICA PARA TRATAR O CONFLITO ---
                if (error.response && error.response.status === 409) {
                  setChangeProfError(error.response.data.message);
                  setAvailableDoctors(error.response.data.available_doctors || []);
                } else {
                  showAlertModal('Erro', `Falha ao alterar profissional: ${error.response?.data?.message || 'Tente novamente.'}`, 'danger');
                }
              } finally {
                setIsUpdatingProfessional(false);
              }
            }}
          >
            {isUpdatingProfessional ? <Spinner as="span" size="sm" /> : 'Confirmar Alteração'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* NOVO: Modal de Confirmação de Cancelamento de Pagamento */}
      <Modal show={showCancelPaymentModal} onHide={() => setShowCancelPaymentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancelar Pagamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Tem certeza que deseja cancelar o pagamento para o agendamento do paciente <strong>{appointmentToCancelPayment?.paciente?.nome}</strong>?</p>
          <Alert variant="warning">
            <strong>Atenção:</strong> Esta ação irá reverter o status do agendamento para "Aguardando Pagamento" e devolverá os materiais utilizados ao estoque.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelPaymentModal(false)} disabled={isCancelingPayment}>Não</Button>
          <Button variant="danger" onClick={handleConfirmCancelPayment} disabled={isCancelingPayment}>
            {isCancelingPayment ? <><Spinner as="span" size="sm" /> Cancelando...</> : 'Sim, Cancelar Pagamento'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* NOVO: Modal de Detalhes do Pagamento */}
      <Modal show={showPaymentDetailsModal} onHide={handleClosePaymentDetailsModal} centered size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Detalhes do Pagamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {selectedPaymentDetails && selectedPaymentDetails.length > 0 ? (
                <Accordion defaultActiveKey="0">
                    {selectedPaymentDetails.map((payment, index) => (
                        <Accordion.Item eventKey={String(index)} key={payment.id}>
                            <Accordion.Header>
                                <div className="d-flex justify-content-between w-100 me-3">
                                    <span>Pagamento #{payment.id}</span>
                                    <span>{new Date(payment.created_at).toLocaleString()}</span>
                                    <span className="fw-bold">{formatCurrency(payment.valor_total_pago)}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <ListGroup variant="flush">
                                    <ListGroup.Item>
                                        <strong>Data:</strong> {new Date(payment.created_at).toLocaleString()}
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong>Forma de Pagamento:</strong> {payment.forma_pagamento}
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong>Valor Total:</strong> {formatCurrency(payment.valor_total_pago)}
                                    </ListGroup.Item>
                                     <ListGroup.Item>
                                        <strong>Serviços Pagos:</strong>
                                        <ul className="list-unstyled mb-0">
                                            {payment.servicos && payment.servicos.map(servico => {
                                                const funcionarioComissao = servico.pivot.funcionario_id && allFuncionarios
                                                    ? allFuncionarios.find(f => f.id === servico.pivot.funcionario_id)
                                                    : null;
                                                
                                                const originalService = selectedAppointmentForDetails?.servicos?.find(s => s.id === servico.id);
                                                const origin = originalService?.origin;

                                                return (
                                                <li key={servico.id} className="mb-2">
                                                    <div>
                                                        {servico.nome} - {formatCurrency(servico.pivot.valor_servico_no_momento_pagamento)}
                                                        {origin && (
                                                            <Badge bg={origin === 'agendamento' ? 'primary' : 'secondary'} className="ms-2" style={{ fontSize: '0.7em' }}>
                                                                {origin === 'agendamento' ? 'Original' : 'Adicional'}
                                                            </Badge>
                                                        )}
                                                    </div>
                                                    {servico.pivot.comissionado == 1 && (
                                                        <div className="text-muted small ms-3">
                                                            <FontAwesomeIcon icon={faMoneyBillWave} className="me-1 text-success" />
                                                            <span className="text-success">
                                                                {servico.pivot.tipo_comissao === 'indicacao' ? 'Comissão por indicação: ' : 'Comissão: '}
                                                                {formatCurrency(servico.pivot.valor_comissao)}
                                                                {servico.pivot.percentual_comissao_pago > 0 && <span className="ms-1 text-muted" style={{ fontSize: '0.85em' }}>({parseFloat(servico.pivot.percentual_comissao_pago).toFixed(2)}%)</span>}
                                                            </span>
                                                            {funcionarioComissao ? <> para <strong>{funcionarioComissao.nome}</strong></> : <span className="text-danger"> (Profissional não encontrado)</span>}
                                                        </div>
                                                    )}
                                                    {/* Opção para adicionar comissão se não houver */}
                                                    {servico.pivot.comissionado == 0 && (currentUserRole === 'Representante Legal' || currentUser?.is_gerente) && (
                                                        <div className="ms-3 mt-1">
                                                            {editingCommission.paymentId === payment.id && editingCommission.serviceId === servico.id ? (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <Form.Select size="sm" value={selectedProfessionalForCommission} onChange={(e) => setSelectedProfessionalForCommission(e.target.value)} style={{ maxWidth: '200px' }}>
                                                                        <option value="">Selecione...</option>
                                                                        {commissionableEmployees.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                                                    </Form.Select>
                                                                    <Form.Control 
                                                                        type="number" 
                                                                        size="sm" 
                                                                        style={{ maxWidth: '70px' }} 
                                                                        value={commissionPercentage} 
                                                                        onChange={(e) => setCommissionPercentage(e.target.value)} 
                                                                        placeholder="%"
                                                                        min="0"
                                                                        max="100"
                                                                    />
                                                                    <span className="small text-muted">%</span>
                                                                    <Button variant="success" size="sm" onClick={() => handleSaveCommission(payment.id, servico.id)} disabled={isAddingCommission}>
                                                                        {isAddingCommission ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faCheck} />}
                                                                    </Button>
                                                                    <Button variant="secondary" size="sm" onClick={handleCancelAddCommission} disabled={isAddingCommission}><FontAwesomeIcon icon={faArrowLeft} /></Button>
                                                                </div>
                                                            ) : (
                                                                <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => handleStartAddCommission(payment.id, servico.id)}>
                                                                    <small><FontAwesomeIcon icon={faPlus} className="me-1" /> Adicionar Comissão</small>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    )}
                                                </li>
                                            )})}
                                        </ul>
                                    </ListGroup.Item>
                                    {payment.valor_adicional > 0 && (
                                        <ListGroup.Item>
                                            <strong>Adicional:</strong> {formatCurrency(payment.valor_adicional)}
                                            {payment.descricao_valor_adicional && ` (${payment.descricao_valor_adicional})`}
                                        </ListGroup.Item>
                                    )}
                                    {payment.valor_desconto > 0 && (
                                        <ListGroup.Item>
                                            <strong>Desconto:</strong> -{formatCurrency(payment.valor_desconto)}
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            ) : (
                <p>Nenhum detalhe de pagamento encontrado.</p>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClosePaymentDetailsModal}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Ações do Agendamento (Card Click) */}
      <Modal show={showActionsModal} onHide={() => setShowActionsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ações do Agendamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {selectedAppointmentForActions && (
                <div className="d-flex flex-column gap-3">
                    <div>
                        <h5>{selectedAppointmentForActions.paciente?.nome}</h5>
                        <p className="mb-1"><strong>Horário:</strong> {selectedAppointmentForActions.hora_marcada.slice(0, 5)}</p>
                        <p className="mb-1"><strong>Status:</strong> <Badge bg={getStatusColors(selectedAppointmentForActions.status).bg}>{selectedAppointmentForActions.status}</Badge></p>
                        {selectedAppointmentForActions.hora_chegada && <p className="mb-1 text-success"><strong>Chegou às:</strong> {new Date(selectedAppointmentForActions.hora_chegada).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</p>}
                    </div>
                    
                    <div className="d-grid gap-2">
                        {/* Check-in */}
                        {selectedAppointmentForActions.status === 'Agendada' && !selectedAppointmentForActions.hora_chegada && (
                            <Button variant="info" onClick={() => { handleCheckIn(selectedAppointmentForActions.id); setShowActionsModal(false); }} disabled={loadingCheckIn[selectedAppointmentForActions.id]}>
                                {loadingCheckIn[selectedAppointmentForActions.id] ? <Spinner size="sm" /> : 'Fazer Check-in'}
                            </Button>
                        )}

                        {/* Chamar Paciente */}
                        {isCurrentUserCorpoClinico && selectedAppointmentForActions.medico_id === currentUser?.id && selectedAppointmentForActions.status === 'Agendada' && selectedAppointmentForActions.hora_chegada && (
                             <Button variant="outline-primary" onClick={() => { handleChamarPaciente(selectedAppointmentForActions.id); }} disabled={loadingChamar[selectedAppointmentForActions.id]}>
                                {loadingChamar[selectedAppointmentForActions.id] ? <Spinner size="sm" /> : <><FontAwesomeIcon icon={['fas', 'bullhorn']} className="me-2" /> Chamar Painel</>}
                            </Button>
                        )}

                        {/* Iniciar Consulta */}
                        {isCurrentUserCorpoClinico && selectedAppointmentForActions.medico_id === currentUser?.id && selectedAppointmentForActions.status === 'Agendada' && (
                            <Button variant={selectedAppointmentForActions.hora_chegada ? "success" : "secondary"} onClick={() => { handleIniciarConsulta(selectedAppointmentForActions.id); setShowActionsModal(false); }} disabled={loadingIniciarConsulta[selectedAppointmentForActions.id] || !selectedAppointmentForActions.hora_chegada}>
                                {loadingIniciarConsulta[selectedAppointmentForActions.id] ? <Spinner size="sm" /> : 'Iniciar Consulta'}
                            </Button>
                        )}

                        {/* Pagamento */}
                        {(((selectedAppointmentForActions.status === 'Agendada' || selectedAppointmentForActions.status === 'Realizada') && selectedAppointmentForActions.payment_status === 'Aguardando Pagamento') ||
                          ((selectedAppointmentForActions.payment_status === 'Pago' || selectedAppointmentForActions.payment_status === 'Aguardando Pagamento') && selectedAppointmentForActions.status === 'Aguardando Pagamento')) ? (
                            canShowPayButton && (
                                <Button variant="outline-danger" onClick={() => { handleOpenPaymentModal(selectedAppointmentForActions); setShowActionsModal(false); }}>
                                    Receber Pagamento
                                </Button>
                            )
                        ) : (
                            (currentUserRole === 'Representante Legal' || currentUser?.is_gerente) && (
                                <Button variant="info" onClick={() => { handleOpenPaymentDetailsModal(selectedAppointmentForActions); setShowActionsModal(false); }}>
                                    Ver Detalhes do Pagamento
                                </Button>
                            )
                        )}

                        {/* Reagendar */}
                        {selectedAppointmentForActions.status === 'Agendada' && !selectedAppointmentForActions.hora_chegada && (
                            <Button variant="outline-secondary" onClick={() => { handleOpenRescheduleModal(selectedAppointmentForActions); setShowActionsModal(false); }}>
                                Reagendar
                            </Button>
                        )}

                        {/* Alterar Profissional */}
                        {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && selectedAppointmentForActions.status === 'Agendada' && (
                            <Button variant="outline-dark" onClick={() => { 
                                setAppointmentToChangeProf(selectedAppointmentForActions);
                                setAvailableDoctors([]);
                                setChangeProfError(null);
                                setNewProfessionalId('');
                                setShowChangeProfModal(true);
                                setShowActionsModal(false);
                            }}>
                                Alterar Profissional
                            </Button>
                        )}

                        {/* Cancelar/Desmarcar (Dropdown logic simplified to buttons for modal) */}
                        {currentUserRole === 'Recepção' && selectedAppointmentForActions.status === 'Agendada' && (
                            <Dropdown className="d-grid">
                                <Dropdown.Toggle variant="outline-secondary" id="dropdown-actions">
                                    Alterar Status
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="w-100">
                                    <Dropdown.Item onClick={() => { handleStatusChange(selectedAppointmentForActions.id, 'Cancelada'); setShowActionsModal(false); }}>Cancelada</Dropdown.Item>
                                    <Dropdown.Item onClick={() => { handleStatusChange(selectedAppointmentForActions.id, 'Desmarcada'); setShowActionsModal(false); }}>Desmarcada</Dropdown.Item>
                                    <Dropdown.Item onClick={() => { handleStatusChange(selectedAppointmentForActions.id, 'Faltou'); setShowActionsModal(false); }}>Faltou</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                         {/* Cancelar Pagamento */}
                         {selectedAppointmentForActions.payment_status === 'Pago' && canShowCancelPayButton && 
                            ((selectedAppointmentForActions.servicos?.length || 0) > 1 || !selectedAppointmentForActions.paciente_pacote_id || selectedAppointmentForActions.pagamento?.length > 0) && (
                            <Button variant="outline-warning" onClick={() => { handleOpenCancelPaymentModal(selectedAppointmentForActions); setShowActionsModal(false); }}>
                                Cancelar Pagamento
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </Modal.Body>
      </Modal>

      {/* Context Menu */}
      {contextMenu && (
          <div style={{ ...styles.contextMenu, top: contextMenu.y, left: contextMenu.x }}>
              <div 
                  className="dropdown-item" 
                  style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                  onClick={() => {
                      setPatientForModal(contextMenu.appointment.paciente);
                      setShowProntuarioModal(true);
                      setContextMenu(null);
                  }}
              >
                  <FontAwesomeIcon icon={faStethoscope} className="me-2" /> Ver Prontuário
              </div>

              {/* Ver Detalhes do Pagamento */}
              {(currentUserRole === 'Representante Legal' || currentUser?.is_gerente) && 
               (contextMenu.appointment.payment_status === 'Pago' || contextMenu.appointment.payment_status === 'Parcial') && (
                  <div 
                      className="dropdown-item" 
                      style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                      onClick={() => {
                          handleOpenPaymentDetailsModal(contextMenu.appointment);
                          setContextMenu(null);
                      }}
                  >
                      <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" /> Ver Detalhes Pagamento
                  </div>
              )}

              {/* Reagendar */}
              {contextMenu.appointment.status === 'Agendada' && !contextMenu.appointment.hora_chegada && (
                  <div 
                      className="dropdown-item" 
                      style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                      onClick={() => {
                          handleOpenRescheduleModal(contextMenu.appointment);
                          setContextMenu(null);
                      }}
                  >
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-2" /> Reagendar
                  </div>
              )}

              {/* Alterar Profissional */}
              {(currentUserRole === 'Recepção' || currentUserRole === 'Representante Legal') && contextMenu.appointment.status === 'Agendada' && (
                  <div 
                      className="dropdown-item" 
                      style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                      onClick={() => {
                          setAppointmentToChangeProf(contextMenu.appointment);
                          setAvailableDoctors([]);
                          setChangeProfError(null);
                          setNewProfessionalId('');
                          setShowChangeProfModal(true);
                          setContextMenu(null);
                      }}
                  >
                      <FontAwesomeIcon icon={faUserMd} className="me-2" /> Alterar Profissional
                  </div>
              )}

              <div className="dropdown-divider"></div>
              <div 
                  className="dropdown-item text-danger" 
                  style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                  onClick={() => {
                      handleStatusChange(contextMenu.appointment.id, 'Cancelada');
                      setContextMenu(null);
                  }}
              >
                  <FontAwesomeIcon icon={faBan} className="me-2" /> Cancelar
              </div>
              <div 
                  className="dropdown-item" 
                  style={{ cursor: 'pointer', padding: '0.25rem 1.5rem' }}
                  onClick={() => {
                      handleStatusChange(contextMenu.appointment.id, 'Faltou');
                      setContextMenu(null);
                  }}
              >
                  <FontAwesomeIcon icon={faUserMd} className="me-2" /> Faltou
              </div>
          </div>
      )}

      <ProntuarioVisualizacaoModal 
          show={showProntuarioModal}
          onHide={() => setShowProntuarioModal(false)}
          paciente={patientForModal}
      />

      {/* Modal de Histórico de Pacotes */}
      <Modal show={showPackageHistoryModal} onHide={() => setShowPackageHistoryModal(false)} size="lg" centered>
        <Modal.Header closeButton>
            <Modal.Title>Histórico de Pacotes - {selectedSidebarAppointment?.paciente?.nome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {isLoadingPackageHistory ? (
                <div className="text-center my-3"><Spinner animation="border" /></div>
            ) : packageHistoryData.length > 0 ? (
                <Accordion defaultActiveKey="0">
                    {packageHistoryData.map((pacote, index) => (
                        <Accordion.Item eventKey={String(index)} key={pacote.id}>
                            <Accordion.Header>
                                <div className="d-flex justify-content-between w-100 pe-2 align-items-center">
                                    <span className="fw-bold">{pacote.servico.nome}</span>
                                    <div>
                                        <Badge bg={pacote.status === 'Ativo' ? 'success' : 'secondary'} className="me-2">{pacote.status}</Badge>
                                        <span className="small text-muted">{pacote.sessoes_utilizadas} / {pacote.sessoes_contratadas} sessões</span>
                                    </div>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <h6 className="small text-muted mb-2">Histórico de Utilização:</h6>
                                {pacote.agendamentos_utilizados && pacote.agendamentos_utilizados.length > 0 ? (
                                    <Table striped bordered hover size="sm" className="mb-0" style={{fontSize: '0.85rem'}}>
                                        <thead><tr><th>Data</th><th>Hora</th><th>Status</th></tr></thead>
                                        <tbody>
                                            {pacote.agendamentos_utilizados.map(ag => (
                                                <tr key={ag.id}>
                                                    <td>{new Date(ag.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR')}</td>
                                                    <td>{ag.hora_marcada.slice(0, 5)}</td>
                                                    <td>{ag.status}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (<p className="small text-muted mb-0">Nenhuma sessão utilizada registrada.</p>)}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            ) : (
                <Alert variant="info">Nenhum histórico de pacotes encontrado para este paciente.</Alert>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowPackageHistoryModal(false)}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AgendasCardTab;
